<template>
  <div class="animated faded">
    <el-form
      class="employee-form-component"
      :model="mData.dataForm"
      :rules="mData.validForm"
      ref="myProfileForm"
      label-position="left"
      @submit.native.prevent
      label-width="180px"
      :class="mData.viewMode == 'create'? 'create' : 'update'"
    >
      <!--Thông tin hành chính-->
      <el-card class="box-card-information-administrative mb-3">
        <div slot="header" class="el-card-header">
          <span class="title-card-header">THÔNG TIN CHUNG</span>
        </div>
        <div class="d-flex w__900">
          <div class="aside__infomation">
            <div class="div-avatar">
              <div class="fd-r">
                <el-form-item
                  label="Ảnh chấm công"
                  prop="administrative_info.avatar_id"
                  class="time-attendance-photo"
                  ref="administrative_info.avatar_id"
                >
                  <el-image
                    v-if="!loadAvatarImage"
                    class="avatar__image"
                    @click="showDetailImage(mData.dataForm.avatarUrl ? mData.dataForm.avatarUrl : 'img/demo.png')"
                    :src="mData.viewMode == 'create' ? mData.dataForm.avatarUrl ? mData.dataForm.avatarUrl : 'img/demo.png' : mData.dataForm.avatarUrl"
                    fit="cover"
                  ></el-image>
                  <el-upload
                    v-if="mData.viewMode != 'employeeInfo'"
                    class="upload-demo"
                    action
                    :show-file-list="false"
                    :auto-upload="false"
                    :accept="mData.fileUploadOption.Anh.accept"
                    :on-change="fn_uploadChangeFile"
                    :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                  >
                    <el-button
                      size="small"
                      class="btn-default"
                      :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    >
                      Tải ảnh
                    </el-button>
                  </el-upload>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="main__infomation">
            <b-row>
              <b-col lg="6" md="12">
                <el-form-item label="Mã nhân viên" prop="employee_no">
                  <el-input
                    ref="employee_no"
                    :disabled="mData.viewMode == 'update' || mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model.trim="mData.dataForm.employee_no"
                    @input="forceUpdateUI"
                    @change="() => {mData.dataForm.employee_no = mData.dataForm.employee_no.toUpperCase()}"
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item
                  label="Họ và tên"
                  prop="administrative_info.name.full_name"
                >
                  <el-input
                    :ref="'administrative_info.name.full_name'"
                    :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model="employeeFullNameInput"
                    @input="handleEmployeeFullNameInput"
                    @change="handleEmployeeFullNameChange"
                  ></el-input>
                </el-form-item>
              </b-col>
              <!-- <b-col lg="6" md="12" v-if="mData.viewMode != 'employeeInfo'">
                <el-form-item label="Công ty" prop="company_id">
                  <el-select
                    v-model="mData.dataForm.company_id"
                    filterable
                    placeholder="Chọn công ty"
                    :disabled="fn_isCompanySelectDisabled()"
                    @change="forceUpdateUI"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listCompanyScope"
                      :key="item.id"
                      :label="fn_companyLabel(item)"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col> -->
              <b-col lg="6" md="12">
                <el-form-item
                  label="Ngày sinh"
                  prop="administrative_info.birthday"
                >
                  <el-date-picker
                    :ref="'administrative_info.birthday'"
                    :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model="mData.dataForm.administrative_info.birthday"
                    type="date"
                    placeholder=""
                    format="dd/MM/yyyy"
                    @input="forceUpdateUI"
                    :picker-options="pickerBirthdayOptions"
                  >
                  </el-date-picker>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item
                  label="Giới tính"
                  prop="administrative_info.gender"
                >
                  <el-select
                    :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model="mData.dataForm.administrative_info.gender"
                    clearable
                    filterable
                    @input="forceUpdateUI"
                    @change="checkStatusVsGender('gender')"
                    ref="administrative_info.gender"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listGioiTinh"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item
                  label="CCCD/CMND/Hộ chiếu"
                  prop="administrative_info.identify_card"
                >
                  <el-input
                    ref="administrative_info.identify_card"
                    :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model.trim="mData.dataForm.administrative_info.identify_card"
                    @change="mData.dataForm.administrative_info.identify_card = mData.dataForm.administrative_info.identify_card.trim()"
                    @input="forceUpdateUI"
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item
                  label="Số điện thoại"
                  prop="administrative_info.phone_number"
                >
                  <el-input
                    ref="administrative_info.phone_number"
                    :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model.trim="mData.dataForm.administrative_info.phone_number"
                    @input="forceUpdateUI"
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item
                  label="Email cá nhân"
                  prop="administrative_info.email"
                >
                  <el-input
                    ref="administrative_info.email"
                    :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model.trim="mData.dataForm.administrative_info.email"
                    @change="mData.dataForm.administrative_info.email = mData.dataForm.administrative_info.email.trim()"
                    @input="forceUpdateUI"
                  ></el-input>
                </el-form-item>
              </b-col>
              <!-- <b-col lg="6" md="12">
                <el-form-item
                  label="Email công ty"
                  prop="administrative_info.company_email"
                >
                  <el-input
                    ref="administrative_info.company_email"
                    :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model.trim="mData.dataForm.administrative_info.company_email"
                    @input="forceUpdateUI"
                  ></el-input>
                </el-form-item>
              </b-col> -->
              <!-- <b-col lg="6" md="12">
                <el-form-item
                  label="Ngày đầu làm việc"
                  prop="start_work_date"
                >
                  <el-date-picker
                    ref="start_work_date"
                    :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model="mData.dataForm.start_work_date"
                    type="date"
                    placeholder=""
                    format="dd/MM/yyyy"
                    @input="forceUpdateUI"
                    @change="calculateSeniority(mData.dataForm.start_work_date)"
                  >
                  </el-date-picker>
                </el-form-item>
              </b-col> -->
              <b-col lg="6" md="12">
                <el-form-item label="Địa chỉ" prop="administrative_info.address">
                  <el-input
                    ref="administrative_info.address"
                    :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model="mData.dataForm.administrative_info.address"
                    @input="forceUpdateUI"
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item label="Trạng thái" prop="status">
                  <el-select
                    :disabled="mData.viewMode == 'create' || mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model="mData.dataForm.status"
                    filterable
                    @input="forceUpdateUI"
                    ref="status"
                    @change="checkStatusVsGender('status')"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listTrangThai"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item
                  label="Số năm thâm niên"
                  prop="seniority"
                >
                  <el-input
                    v-if="showSeniority"
                    disabled
                    v-model.trim="mData.dataForm.seniority"
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12" v-if="mData.viewMode == 'create'">
                <el-form-item class="account" label="Tài khoản" prop="account">
                  <div class="d-flex" v-if="mData.viewMode == 'create'">
                    <p style="text-transform: lowercase; font-weight: bold; margin-top: 10px;">
                      {{ fn_selectedCompanyPrefix() }}_
                    </p>
                    <el-input
                      ref="account"
                      :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                      v-model.trim="mData.dataForm.account"
                      @input="forceUpdateUI"
                    ></el-input>
                  </div>
                  <div v-if="mData.viewMode != 'create'">
                    <p class="mt-1" style="text-transform: lowercase">
                      {{ mData.dataForm.account }}
                    </p>
                  </div>
                </el-form-item>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="d-flex w__900 mt-1">
          <div class="aside__infomation aside__infomation--spacer"></div>
          <div class="main__infomation">
          <b-row>
            <b-col xl="12" md="12" class="job-info-item"
              v-for="(item, index) in mData.dataForm.job_info"
              :key="index"
            >
              <div class="job-info-group mb-1">
                <b-row>
                  <b-col xl="6" sm="12" 
                    v-if="mData.viewMode != 'employeeInfo'">
                    <el-form-item label="Công ty" prop="company_id">
                      <el-select
                        v-model="mData.dataForm.company_id"
                        filterable
                        placeholder="Chọn công ty"
                        :disabled="fn_isCompanySelectDisabled()"
                        @change="forceUpdateUI"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listCompanyScope"
                          :key="item.id"
                          :label="fn_companyLabel(item)"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col xl="6" sm="12">
                    <el-form-item
                      label="Chi nhánh"
                      :prop="'job_info[' + index + '].branch_id'"
                    >
                      <el-select
                        :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                        v-model="item.branch_id"
                        clearable
                        filterable
                        @input="forceUpdateUI"
                        @blur="validateFieldMethod(`job_info[${index}].branch_id`)"
                        :ref="`job_info[${index}].branch_id`"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listChiNhanh"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col xl="6" sm="12">
                    <el-form-item
                      label="Phòng ban"
                      :prop="'job_info[' + index + '].department_id'"
                    >
                      <el-select
                        :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                        v-model="item.department_id"
                        clearable
                        filterable
                        @input="forceUpdateUI"
                        @blur="validateFieldMethod(`job_info[${index}].department_id`)"
                        :ref="`job_info[${index}].department_id`"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listPhongBan"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col xl="6" sm="12">
                    <el-form-item
                      label="Quản lý trực tiếp"
                      :prop="'job_info[' + index + '].direct_manager_id'"
                    >
                      <el-select
                        :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                        v-model="item.direct_manager_id"
                        clearable
                        filterable
                        @input="forceUpdateUI"
                        @blur="validateFieldMethod(`job_info[${index}].direct_manager_id`)"
                        :ref="`job_info[${index}].direct_manager_id`"
                        >
                        <el-option
                          v-for="manager in mData.dataDefault.listNhanVien"
                          :key="manager.id"
                          :label="manager.name"
                          :value="manager.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col xl="6" sm="12">
                    <el-form-item
                      label="Chức vụ"
                      :prop="'job_info[' + index + '].position_id'"
                    >
                      <el-select
                        :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                        v-model="item.position_id"
                        clearable
                        filterable
                        @input="forceUpdateUI"
                        @blur="validateFieldMethod(`job_info[${index}].position_id`)"
                        :ref="`job_info[${index}].position_id`"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listChucVu"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col xl="6" sm="12">
                    <el-form-item
                      label="Ca làm"
                      :prop="fn_activeShiftProp()"
                      :rules="fn_activeShiftRules()"
                    >
                      <el-select
                        v-if="mData.dataForm.shift.some(s => !s.expiredShift)"
                        :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                        v-model="mData.dataForm.shift[mData.dataForm.shift.findIndex(s => !s.expiredShift)].shift_id"
                        :ref="`shift[${mData.dataForm.shift.findIndex(s => !s.expiredShift)}].shift_id`"
                        clearable
                        filterable
                        @change="handleActiveShiftChange"
                      >
                        <el-option
                          v-for="shift in mData.dataDefault.listCaLamViec"
                          :key="shift.id"
                          :label="shift.code + ` (${formatDate(shift.applied_start_time)} - ${formatDate(shift.applied_end_time)})`"
                          :value="shift.id"
                        ></el-option>
                      </el-select>
                      <el-select
                        v-else
                        :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                        ref="shift[0].shift_id"
                        value=""
                        clearable
                        filterable
                        @change="handleEmptyShiftChange"
                      >
                        <el-option
                          v-for="shift in mData.dataDefault.listCaLamViec"
                          :key="shift.id"
                          :label="shift.code + ` (${formatDate(shift.applied_start_time)} - ${formatDate(shift.applied_end_time)})`"
                          :value="shift.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col xl="6" sm="12">
                    <el-form-item
                      label="Loại hợp đồng"
                      :prop="'job_info[' + index + '].contract_type_id'"
                      v-if="loadContracType"
                    >
                      <el-select
                        :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                        v-model="item.contract_type_id"
                        clearable
                        filterable
                        @input="forceUpdateUI"
                        :ref="`job_info[${index}].contract_type_id`"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listLoaiHopDong"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col xl="6" sm="12">
                    <el-form-item
                      label="Ngày bắt đầu"
                      :prop="'job_info[' + index + '].start_date'"
                      v-if="loadTimeStartCT"
                    >
                      <el-date-picker
                        :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                        v-model="item.start_date"
                        type="date"
                        format="dd/MM/yyyy"
                        @change="changeTimeStartInfomationJod(index)"
                        @blur="validateFieldMethod(`job_info[${index}].start_date`)"
                        @input="forceUpdateUI"
                        :ref="`job_info[${index}].start_date`"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </b-col>
                  <b-col xl="6" sm="12">
                    <el-form-item
                      label="Kiểu hợp đồng"
                      :prop="'job_info[' + index + '].kind_of_contract'"
                    >
                      <el-select
                        :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                        v-model="item.kind_of_contract"
                        clearable
                        filterable
                        @input="forceUpdateUI"
                        @blur="validateFieldMethod(`job_info[${index}].kind_of_contract`)"
                        @change="checkHaveLaborContract()"
                        :ref="`job_info[${index}].kind_of_contract`"
                      >
                        <el-option
                          v-for="item in DataService.listKindOfContract"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col xl="6" sm="12">
                    <el-form-item
                      label="Ngày kết thúc"
                      :prop="'job_info[' + index + '].end_date'"
                    >
                      <el-date-picker
                        :disabled="
                          mData.viewMode == 'detail' || !item.start_date || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')
                        "
                        v-model="item.end_date"
                        type="date"
                        format="dd/MM/yyyy"
                        @change="changeTimeEndInfomationJod(index)"
                        @input="forceUpdateUI"
                        @blur="validateFieldMethod(`job_info[${index}].end_date`)"
                        :ref="`job_info[${index}].end_date`"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </b-col>
                  <b-col xl="6" sm="12">
                    <el-form-item
                      label="Ngày bắt đầu làm việc chính thức"
                      :prop="'job_info[' + index + '].official_labor_contract_signed_date'"
                    >
                      <el-date-picker
                        :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                        v-model="item.official_labor_contract_signed_date"
                        type="date"
                        format="dd/MM/yyyy"
                        @blur="validateFieldMethod(`job_info[${index}].official_labor_contract_signed_date`)"
                        @input="forceUpdateUI"
                        :ref="`job_info[${index}].official_labor_contract_signed_date`"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </b-col>
                  <b-col cols="12">
                    <el-form-item
                      label="Không chấm công"
                      :prop="
                        mData.dataForm.shift.some(s => !s.expiredShift)
                          ? 'shift[' + mData.dataForm.shift.findIndex(s => !s.expiredShift) + '].is_need_checkin'
                          : ''
                      "
                    >
                        <el-switch
                          v-if="mData.dataForm.shift.some(s => !s.expiredShift)"
                          :disabled="mData.viewMode == 'detail'"
                        v-model="mData.dataForm.shift[mData.dataForm.shift.findIndex(s => !s.expiredShift)].is_need_checkin"
                        inactive-color="var(--orange)"
                        active-color="#DCDFE6"
                        @change="handleActiveShiftCheckinChange"
                      >
                      </el-switch>
                      <el-switch
                        v-else
                        disabled
                        inactive-color="var(--orange)"
                        active-color="#DCDFE6"
                      >
                      </el-switch>
                    </el-form-item>
                  </b-col>
                  <b-col lg="3" sm="12">
                    <el-form-item
                      label="Upload hồ sơ"
                      prop="administrative_info.facebook"
                    >
                      <el-upload
                        class="employee-file"
                        :auto-upload="false"
                        list-type="text"
                        drag
                        action
                        :limit="mData.fileUploadOption.FileHoSo.limit"
                        :accept="mData.fileUploadOption.FileHoSo.accept"
                        :on-change="fn_uploadFile"
                        :on-preview="fn_downloadFile"
                        :on-remove="fn_removeFile"
                        :file-list="mData.fileUploadOption.FileHoSo.fileList"
                        :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                        multiple
                      >
                        <div class="el-upload__text">
                          Thả file vào đây hoặc <em>click để upload</em>
                        </div>
                      </el-upload>
                    </el-form-item>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          </div>
        </div>
        <b-col md="12" class="social-div">
          <div
            class="add-new-social__network"
          >
            <p
              v-if="!checkEnoughSocialNetwork"
              @click="addNewSocialNetwork"
              class="add-new-social__network-text"
            >
              <span class="plus">+ </span>
              <span class="underline">Liên kết xã hội</span>
            </p>
            <p
              v-if="checkEnoughSocialNetwork"
              class="mr-4"
            >
              Liên kết xã hội
            </p>
          </div>

          <div
            class="social-media"
          >
            <div>
              <div
                v-for="(e,i) in mData.dataForm.social_networks"
                :key="i"
                class="social-media__box"
              >
                <img :src="`img/${e.type}.png`" alt="" class="social__media-icon">
                <p
                  @click="goToLinkUrl(e.url)"
                  class="social-network__url"
                  :title="e.url"
                >
                  {{e.url}}
                </p>
                <i v-if="mData.viewMode != 'detail' && mData.viewMode != 'employeeInfo' && mData.dataDefault.listFeature.includes('FT103') && mData.dataDefault.listFeature.includes('FT104')" class="isax-save-remove" title="Xóa" @click="removeSocialNetwork(i)"></i>
                <i v-if="mData.viewMode != 'detail' && mData.viewMode != 'employeeInfo' && mData.dataDefault.listFeature.includes('FT103') && mData.dataDefault.listFeature.includes('FT104')" class="isax-edit" title="Cập nhật" @click="updateSocialNetwork(e)"></i>
              </div>
            </div>
          </div>
        </b-col>
      </el-card>

      <!--Thông tin chấm công-->
      <!-- <el-card class="box-card mb-3">
        <div slot="header" class="el-card-header">
          <span class="title-card-header" style="text-transform: uppercase;">Thông tin chấm công</span>
        </div>
        <div> -->
          <!-- <b-row class="mb-3">
            <b-col xl="2">
              <el-checkbox
                :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                v-model="mData.isHaveTheChamCong"
                @input="forceUpdateUI"
              >Thẻ chấm công</el-checkbox>
            </b-col>
            <b-col xl="4" v-if="mData.isHaveTheChamCong === true">

              <el-form-item prop="card_no">
                <el-input
                  :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                  v-model="mData.dataForm.card_no"
                  @input="forceUpdateUI"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row> -->
          <!-- <b-row> -->
            <!-- v-if="new Date().getTime() >= new Date(item.start_time).getTime()  &&  new Date().getTime() <= new Date(item.end_time).getTime()" -->
            <!-- <b-col
              xl="6"
              md="12"
              v-for="(item, index) in mData.dataForm.shift"
              :key="index"
              :class="{ hide_div: item.expiredShift }"
            >
              <div class="p-relative">
                <div
                  class="remove-icon c-ponit"
                  v-if="mData.viewMode != 'detail' && mData.viewMode != 'employeeInfo'"
                  @click="removeInformationTimekeeping(item.key,index)"
                >
                  <el-image
                    style="width: 100%"
                    src="img/remove_icon.png"
                    fit="cover"
                  >
                  </el-image>
                </div>
              </div>
              <el-card class="box-card-information-timekeeping mb-3">
                <b-row>
                  <b-col cols="12">
                    <el-form-item
                      label="Ca làm"
                      :prop="'shift[' + index + '].shift_id'"
                      v-if="loadShift"
                    >
                      <el-select
                        :disabled="
                          mData.viewMode != 'create' && item.key_dataSave
                        "
                        v-model.lazy="item.shift_id"
                        filterable
                        @input="forceUpdateUI"
                        @change="changeShift(index, item.shift_id)"
                        @blur="validateFieldMethod(`shift[${index}].shift_id`)"
                        :ref="`shift[${index}].shift_id`"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listCaLamViec"
                          :key="item.id"
                          :label="
                            item.code +
                            ` (${formatDate(
                              item.applied_start_time
                            )} - ${formatDate(item.applied_end_time)})`
                          "
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col cols="12">
                    <el-form-item
                      label="Ngày bắt đầu"
                      :prop="'shift[' + index + '].start_time'"
                      v-if="loadTimeStart"
                    >
                      <el-date-picker
                        :disabled="
                          mData.viewMode != 'create' && item.key_dataSave
                        "
                        v-model="item.start_time"
                        clearable
                        type="date"
                        placeholder=""
                        format="dd/MM/yyyy"
                        @blur="validateFieldMethod(`shift[${index}].start_time`)"
                        @input="forceUpdateUI"
                        @focus="setDisableTime(index)"
                        @change="changeTimeStart(index)"
                        :picker-options="pickerOptions"
                        :ref="`shift[${index}].start_time`"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </b-col>
                  <b-col cols="12">
                    <el-form-item
                      label="Ngày kết thúc"
                      :prop="'shift[' + index + '].end_time'"
                    >
                      <el-date-picker
                        :disabled="
                          mData.viewMode == 'detail' || !item.start_time || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')
                        "
                        v-model="item.end_time"
                        clearable
                        type="date"
                        format="dd/MM/yyyy"
                        @focus="setDisableTime(index)"
                        @change="changeTimeEnd(index)"
                        :picker-options="pickerOptions"
                        @input="forceUpdateUI"
                        :ref="`shift[${index}].end_time`"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </b-col>
                  <b-col cols="12">
                    <el-form-item
                      label="Không chấm công"
                      :prop="'shift[' + index + '].is_need_checkin'"
                    >
                      <el-switch
                        :disabled="
                          mData.viewMode != 'create' && item.key_dataSave
                        "
                        v-model="item.is_need_checkin"
                        inactive-color="var(--orange)"
                        active-color="#DCDFE6"
                        @input="forceUpdateUI"
                      >
                      </el-switch>
                    </el-form-item>
                  </b-col>
                </b-row>
              </el-card>
            </b-col>
          </b-row>
          <div
            class="d-flex jc-end"
          >
            <el-link
              v-if="mData.viewMode != 'create' && mData.haveHistoryShift"
              type="primary"
              style="color: blue"
              @click="mData.showHistoryShift = true"
            >
              Xem lịch sử
            </el-link>
            <div
              v-if="mData.viewMode != 'detail' && mData.viewMode != 'employeeInfo' || mData.dataDefault.listFeature.includes('FT103') || mData.dataDefault.listFeature.includes('FT104')"
              class="img__icon-plus mouse__hover ml-2"
              @click="newInformationTimekeeping"
            >
              <el-image
                src="img/plus.png"
                fit="cover"
              ></el-image>
            </div>
          </div>
        </div>
      </el-card> -->


      <!-- Tiền lương trợ cấp-->
      <el-collapse class="box-card-salary mb-3" v-model="activeName5" accordion>
        <el-collapse-item name="box-card-salary">
          <template slot="title">
            <span class="title-card-header">Tiền lương/Trợ cấp</span>
          </template>
          <div>
            <b-row style="position: relative">
              <b-col md="6">
                <el-form-item
                  label="Hình thức chi trả"
                  prop="salary.payment_method"
                >
                  <el-input
                    :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model="mData.dataForm.salary.payment_method"
                    clearable
                    @input="forceUpdateUI"
                    :ref="`salary.payment_method`"
                  >
                  </el-input>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item label="Bậc lương" prop="salary.rank_salary_id">
                  <el-select
                    :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model="mData.dataForm.salary.rank_salary_id"
                    clearable
                    filterable
                    @input="forceUpdateUI"
                    :ref="`salary.rank_salary_id`"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listBacLuong"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item label="Ngân hàng" prop="salary.bank_name">
                  <el-input
                    :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model="mData.dataForm.salary.bank_name"
                    clearable
                    @input="forceUpdateUI"
                    :ref="`salary.bank_name`"
                  >
                  </el-input>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item
                  label="Hệ số lương"
                  prop="salary.coefficient_salary_id"
                >
                  <el-select
                    :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model="mData.dataForm.salary.coefficient_salary_id"
                    clearable
                    filterable
                    @input="forceUpdateUI"
                    :ref="`salary.coefficient_salary_id`"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listHeSoLuong"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item label="Số tài khoản" prop="salary.">
                  <el-input
                    :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model="mData.dataForm.salary.bank_account"
                    clearable
                    @input="forceUpdateUI"
                    :ref="`salary.bank_account`"
                  >
                  </el-input>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item
                  label="Lương Gross"
                  prop="salary.gross_salary"
                >
                  <ElementUIMoney
                    v-model="mData.dataForm.salary.gross_salary"
                    label=""
                    :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    :outlined="true"
                    :clearable="true"
                    :options="options"
                    :refProp="`salary.gross_salary`"
                    :ref="`salary.gross_salary`"
                  />
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item label="Chi nhánh" prop="salary.bank_branch">
                  <el-input
                    :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model="mData.dataForm.salary.bank_branch"
                    clearable
                    @input="forceUpdateUI"
                    :ref="`salary.bank_branch`"
                  >
                  </el-input>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item
                  label="Lương đóng bảo hiểm"
                  prop="salary.insurance_salary"
                >
                  <ElementUIMoney
                    @blurInput="validateFieldMethod('salary.insurance_salary')"
                    v-model="mData.dataForm.salary.insurance_salary"
                    label=""
                    :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    :outlined="true"
                    :clearable="true"
                    :options="options"
                    :refProp="`salary.insurance_salary`"
                    :ref="`salary.insurance_salary`"
                  />
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item
                  label="Số sổ bảo hiểm"
                  prop="insurance_book_number"
                >
                  <el-input
                    :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                    v-model.trim="mData.dataForm.insurance_book_number"
                    @change="() => {
                      mData.dataForm.insurance_book_number = mData.dataForm.insurance_book_number.trim();
                      validateFieldMethod('insurance_book_number');
                    }"
                    @blur="validateFieldMethod('insurance_book_number')"
                    :ref="`insurance_book_number`"
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col xl="12" class="subsidize">
                <el-form-item
                  label="Trợ cấp"
                >
                  <b-row
                    v-for="(item, index) in mData.dataForm.salary.subsidies_salary"
                    :key="index"
                    style="margin-left: -3px"
                  >
                    <b-col xl="4" sm="3" class="pl-1">
                      <el-form-item
                        :prop="
                          'salary.subsidies_salary[' +
                          index +
                          '].subsidies_salary_type_id'
                        "
                      >
                        <el-select
                          class="mb-1"
                          :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.subsidies_salary_type_id"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                          :ref="`salary.subsidies_salary[${index}].subsidies_salary_type_id`"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listTroCap"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col xl="4" sm="3">
                      <el-form-item
                        :prop="'salary.subsidies_salary[' + index + '].value'"
                      >
                        <ElementUIMoney
                          @blurInput="validateFieldMethod(`salary.subsidies_salary[${index}].value`)"
                          v-model="item.value"
                          :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          label=""
                          :outlined="true"
                          placeholder="Giá trị trợ cấp"
                          :clearable="true"
                          :options="options"
                          :refProp="`salary.subsidies_salary[${index}].value`"
                          :ref="`salary.subsidies_salary[${index}].value`"
                        />
                      </el-form-item>
                    </b-col>
                    <b-col
                      class="icon-remove"
                      xl="1"
                      sm="1"
                      v-if="mData.viewMode != 'detail' && mData.viewMode != 'employeeInfo'"
                    >
                      <div class="d-flex at-center">
                        <el-button
                          style="margin-top: 3px;"
                          circle
                          @click="removeRow(item.key,index)"
                          class="btn-remove-row btn-default"
                          :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                        >
                          <i class="fal fa-trash-alt"></i>
                        </el-button>
                        <div
                          v-if="mData.viewMode != 'detail' && mData.viewMode != 'employeeInfo' || mData.dataDefault.listFeature.includes('FT103') || mData.dataDefault.listFeature.includes('FT104')"
                        >
                          <div
                            v-if="index == mData.dataForm.salary.subsidies_salary.length - 1"
                            class="img__icon-plus mouse__hover ml-3"
                            @click="addRow"
                          >
                            <el-image
                              src="img/plus.png"
                              fit="cover"
                            ></el-image>
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </el-form-item>
              </b-col>
            </b-row>
          </div>
        </el-collapse-item>
      </el-collapse>

      <!--Trình độ chuyên môn-->
      <el-collapse class="box-card mb-3" v-model="activeName2" accordion>
        <el-collapse-item name="box-card-qualification">
          <template slot="title">
            <span class="title-card-header">Trình độ chuyên môn</span>
          </template>
          <div>
            <b-row>
              <b-col
                xl="6"
                v-for="(item, index) in mData.dataForm.qualification"
                :key="index"
              >
                <div class="p-relative">
                  <div
                    title="Xóa"
                    class="remove-icon c-ponit"
                    v-if="mData.viewMode != 'detail' && mData.viewMode != 'employeeInfo'"
                    @click="removeQualification(item.key,index)"
                  >
                    <el-image
                      style="width: 100%"
                      src="img/remove_icon.png"
                      fit="cover"
                    >
                    </el-image>
                  </div>
                </div>
                <el-card class="box-card-qualification mb-3">
                  <b-row>
                    <b-col sm="12">
                      <el-form-item
                        label="Trình độ"
                        :prop="'qualification[' + index + '].qualification_id'"
                      >
                        <el-select
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.qualification_id"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`qualification[${index}].qualification_id`)"
                          :ref="`qualification[${index}].qualification_id`"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listTrinhDo"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col sm="12">
                      <el-form-item
                        label="Chuyên ngành"
                        :prop="'qualification[' + index + '].major_id'"
                      >
                        <el-select
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.major_id"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`qualification[${index}].major_id`)"
                          :ref="`qualification[${index}].major_id`"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listChuyenNganh"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col sm="12">
                      <el-form-item
                        label="Ngày cấp"
                        :prop="'qualification[' + index + '].issued_date'"
                      >
                        <el-date-picker
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.issued_date"
                          type="date"
                          format="dd/MM/yyyy"
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`qualification[${index}].issued_date`)"
                          :ref="`qualification[${index}].issued_date`"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col sm="12">
                      <el-form-item
                        label="Nơi cấp"
                        :prop="'qualification[' + index + '].issued_by'"
                      >
                        <el-input
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.issued_by"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`qualification[${index}].issued_by`)"
                          :ref="`qualification[${index}].issued_by`"
                        >
                        </el-input>
                      </el-form-item>
                    </b-col>
                    <b-col xl="12">
                      <el-form-item
                        label="Ghi chú"
                        :prop="'qualification[' + index + '].note'"
                      >
                        <el-input
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.note"
                          type="textarea"
                          :rows="2"
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`qualification[${index}].note`)"
                          :ref="`qualification[${index}].note`"
                        >
                        </el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </el-card>
              </b-col>
            </b-row>
            <div
              class="d-flex jc-end"
            >
              <div
                v-if="mData.viewMode != 'detail' && mData.viewMode != 'employeeInfo' || mData.dataDefault.listFeature.includes('FT103') || mData.dataDefault.listFeature.includes('FT104')"
                class="img__icon-plus mouse__hover ml-2"
                @click="newQualification"
              >
                <el-image
                  src="img/plus.png"
                  fit="cover"
                ></el-image>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>

      <!--Chững chỉ-->
      <el-collapse class="box-card mb-3" v-model="activeName3" accordion>
        <el-collapse-item name="box-card-certificate">
          <template slot="title">
            <span class="title-card-header">Chứng chỉ</span>
          </template>
          <div>
            <b-row>
              <b-col
                xl="6"
                v-for="(item, index) in mData.dataForm.certificate"
                :key="index"
              >
                <div class="p-relative">
                  <div
                    title="Xóa"
                    class="remove-icon c-ponit"
                    v-if="mData.viewMode != 'detail' && mData.viewMode != 'employeeInfo'"
                    @click="removeCertificate(item.key,index)"
                  >
                    <el-image
                      style="width: 100%"
                      src="img/remove_icon.png"
                      fit="cover"
                    >
                    </el-image>
                  </div>
                </div>
                <el-card class="box-card-certificate mb-3">
                  <b-row>
                    <b-col xl="12">
                      <el-form-item
                        label="Tên chứng chỉ"
                        :prop="'certificate[' + index + '].name'"
                      >
                        <el-input
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.name"
                          clearable
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`certificate[${index}].name`)"
                          :ref="`certificate[${index}].name`"
                        >
                        </el-input>
                      </el-form-item>
                    </b-col>
                    <b-col sm="12">
                      <el-form-item
                        label="Ngày cấp"
                        :prop="'certificate[' + index + '].issued_date'"
                      >
                        <el-date-picker
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.issued_date"
                          type="date"
                          format="dd/MM/yyyy"
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`certificate[${index}].issued_date`)"
                          :ref="`certificate[${index}].issued_date`"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col sm="12">
                      <el-form-item
                        label="Nơi cấp"
                        :prop="'certificate[' + index + '].issued_by'"
                      >
                        <el-input
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.issued_by"
                          clearable
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`certificate[${index}].issued_by`)"
                          :ref="`certificate[${index}].issued_by`"
                        >
                        </el-input>
                      </el-form-item>
                    </b-col>
                    <b-col xl="12">
                      <el-form-item
                        label="Ghi chú"
                        :prop="'certificate[' + index + '].note'"
                      >
                        <el-input
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.note"
                          type="textarea"
                          :rows="2"
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`certificate[${index}].note`)"
                          :ref="`certificate[${index}].note`"
                        >
                        </el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </el-card>
              </b-col>
            </b-row>
            <div
              class="d-flex jc-end"
            >
              <div
                v-if="mData.viewMode != 'detail' && mData.viewMode != 'employeeInfo' || mData.dataDefault.listFeature.includes('FT103') || mData.dataDefault.listFeature.includes('FT104')"
                class="img__icon-plus mouse__hover ml-2"
                @click="newCertificate"
              >
                <el-image
                  src="img/plus.png"
                  fit="cover"
                ></el-image>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>

      <!-- Thông tin liên hệ khác-->
      <el-collapse class="box-card-other mb-3" v-model="activeName4" accordion>
        <el-collapse-item name="box-card-other-contact-information">
          <template slot="title">
            <span class="title-card-header">Thông tin liên hệ khác</span>
          </template>
          <div>
            <b-row>
              <b-col
                xl="6"
                v-for="(item, index) in mData.dataForm.other_contact_info"
                :key="index"
              >
                <div class="p-relative">
                  <div
                    title="Xóa"
                    class="remove-icon c-ponit"
                    v-if="mData.viewMode != 'detail' && mData.viewMode != 'employeeInfo'"
                    @click="removeOtherContactInformation(item.key,index)"
                  >
                    <el-image
                      style="width: 100%"
                      src="img/remove_icon.png"
                      fit="cover"
                    >
                    </el-image>
                  </div>
                </div>
                <el-card class="box-card-qualification mb-3">
                  <b-row>
                    <b-col sm="12">
                      <el-form-item
                        label="Họ và tên"
                        :prop="'other_contact_info[' + index + '].full_name'"
                      >
                        <el-input
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.full_name"
                          clearable
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`other_contact_info[${index}].full_name`)"
                          :ref="`other_contact_info[${index}].full_name`"
                        >
                        </el-input>
                      </el-form-item>
                    </b-col>
                    <b-col sm="12">
                      <el-form-item
                        label="Quan hệ"
                        :prop="
                          'other_contact_info[' + index + '].relationship_id'
                        "
                      >
                        <el-select
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.relationship_id"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`other_contact_info[${index}].relationship_id`)"
                          :ref="`other_contact_info[${index}].relationship_id`"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listMoiQuanHe"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col sm="12">
                      <el-form-item
                        label="Điện thoại"
                        :prop="'other_contact_info[' + index + '].phone_number'"
                      >
                        <el-input
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.phone_number"
                          clearable
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`other_contact_info[${index}].phone_number`)"
                          :ref="`other_contact_info[${index}].phone_number`"
                        >
                        </el-input>
                      </el-form-item>
                    </b-col>
                    <b-col xl="12">
                      <el-form-item
                        label="Địa chỉ"
                        :prop="'other_contact_info[' + index + '].address'"
                      >
                        <el-input
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.address"
                          clearable
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`other_contact_info[${index}].address`)"
                          :ref="`other_contact_info[${index}].address`"
                        >
                        </el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </el-card>
              </b-col>
            </b-row>
            <div
              class="d-flex jc-end"
            >
              <div
                v-if="mData.viewMode != 'detail' && mData.viewMode != 'employeeInfo' || mData.dataDefault.listFeature.includes('FT103') || mData.dataDefault.listFeature.includes('FT104')"
                class="img__icon-plus mouse__hover ml-2"
                @click="newOtherContactInformation"
              >
                <el-image
                  src="img/plus.png"
                  fit="cover"
                ></el-image>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>

      <!-- Thông tin người phụ thuộc -->
      <el-collapse class="box-card mb-3" v-model="activeName6" accordion>
        <el-collapse-item name="box-card-dependent-person">
          <template slot="title">
            <span class="title-card-header">Thông tin người phụ thuộc</span>
          </template>
          <div>
            <b-row>
              <b-col
                xl="6"
                v-for="(item, index) in mData.dataForm.dependent_person_info"
                :key="index"
              >
                <div class="p-relative">
                  <div
                    title="Xóa"
                    class="remove-icon c-ponit"
                    v-if="mData.viewMode != 'detail' && mData.viewMode != 'employeeInfo'"
                    @click="removeDependentPerson(item.key,index)"
                  >
                    <el-image
                      style="width: 100%"
                      src="img/remove_icon.png"
                      fit="cover"
                    >
                    </el-image>
                  </div>
                </div>
                <el-card class="box-card-qualification mb-3">
                  <b-row>
                    <b-col xl="12">
                      <el-form-item
                        label="Họ và tên"
                        :prop="'dependent_person_info[' + index + '].full_name'"
                      >
                        <el-input
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.full_name"
                          clearable
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`dependent_person_info[${index}].full_name`)"
                          :ref="`dependent_person_info[${index}].full_name`"
                        >
                        </el-input>
                      </el-form-item>
                    </b-col>
                    <b-col xl="12">
                      <el-form-item
                        label="Mối quan hệ"
                        :prop="
                          'dependent_person_info[' + index + '].relationship_id'
                        "
                      >
                        <el-select
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.relationship_id"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                          @blur="validateFieldMethod(`dependent_person_info[${index}].relationship_id`)"
                          :ref="`dependent_person_info[${index}].relationship_id`"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listMoiQuanHe"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item
                        label="Ngày đăng ký"
                        :prop="
                          'dependent_person_info[' + index + '].registered_date'
                        "
                      >
                        <el-date-picker
                          :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                          v-model="item.registered_date"
                          type="date"
                          format="dd/MM/yyyy"
                          @input="forceUpdateUI"
                          @change="changeTimeStartDependentPerson(index)"
                          @blur="validateFieldMethod(`dependent_person_info[${index}].registered_date`)"
                          :ref="`dependent_person_info[${index}].registered_date`"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item
                        label="Ngày hết hạn"
                        :prop="
                          'dependent_person_info[' + index + '].expired_date'
                        "
                      >
                        <el-date-picker
                          :disabled="
                            mData.viewMode == 'detail' || !item.registered_date
                          "
                          v-model="item.expired_date"
                          type="date"
                          placeholder=""
                          format="dd/MM/yyyy"
                          @input="forceUpdateUI"
                          @change="changeTimeEndDependentPerson(index)"
                          @blur="validateFieldMethod(`dependent_person_info[${index}].expired_date`)"
                          :ref="`dependent_person_info[${index}].expired_date`"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </el-card>
              </b-col>
            </b-row>
            <div
              class="d-flex jc-end"
            >
              <div
                v-if="mData.viewMode != 'detail' && mData.viewMode != 'employeeInfo' || mData.dataDefault.listFeature.includes('FT103') || mData.dataDefault.listFeature.includes('FT104')"
                class="img__icon-plus mouse__hover ml-2"
                @click="newDependentPerson"
              >
                <el-image
                  src="img/plus.png"
                  fit="cover"
                ></el-image>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>

      <!-- Thông tin chữ ký nhân viên -->
      <el-collapse class="box-card mb-3" v-model="activeName7" accordion="">
        <el-collapse-item name="box-card-sign">
          <template slot="title">
            <span class="title-card-header">Thông tin chữ ký nhân viên</span>
          </template>
          <div>
            <b-row>
              <b-col md="12">
                <el-form-item label="Ảnh chữ ký" class="employee-sign">
                  <el-upload
                    class="signature-upload"
                    :auto-upload="false"
                    drag
                    action
                    :show-file-list="false"
                    :accept="mData.fileUploadOption.FileChuKy.accept"
                    :on-change="fn_uploadSign"
                    :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                  >
                    <div
                      v-if="fn_getFirstSignImage()"
                      class="signature-upload-preview"
                    >
                      <el-image
                        class="signature-upload-image"
                        :src="fn_getFirstSignImage().url"
                        fit="contain"
                      ></el-image>
                      <el-button
                        class="btn-back signature-upload-delete"
                        v-if="fn_canEditSignature()"
                        @click.stop="fn_removeSignImage(fn_getFirstSignImage().id)"
                        title="Xóa"
                      >
                        <i class="el-icon-delete"></i>
                      </el-button>
                    </div>
                    <template v-else>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        Thả ảnh vào đây hoặc <em>click để upload</em>
                      </div>
                    </template>
                    <div class="el-upload__tip" slot="tip">
                      <p><i>Chỉ tải ảnh có định dạng PNG, có kích thước không quá 220 x 220px</i></p>
                    </div>
                  </el-upload>
                </el-form-item>
              </b-col>
            </b-row>
          </div>
        </el-collapse-item>
      </el-collapse>

      <!-- Thông tin đơn vị nhân viên -->
      <!-- <el-collapse class="box-card mb-1" v-model="activeName8" accordion="">
        <el-collapse-item name="box-card-business">
          <template slot="title">
            <span class="title-card-header">Thông tin đơn vị nhân viên</span>
          </template>
          <div>
            <el-form-item prop="" label="Mô hình tổ chức" >
              <el-select-tree
                class="select__tree-custom"
                placeholder="Chọn"
                :data="mData.dataDefault.listOrganizationModelTree"
                v-model="mData.dataForm.organization_model_id"
                :disabled="mData.viewMode == 'detail' || mData.viewMode == 'employeeInfo' || !mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104')"
                check-strictly
                filterable
              ></el-select-tree>
            </el-form-item>
          </div>
        </el-collapse-item>
      </el-collapse> -->

      <!-- dialog show lịch sử ca làm việc -->
      <el-dialog
        :visible.sync="mData.showHistoryShift"
        :close-on-click-modal="true"
        width="60%"
        top="35px"
        title="Lịch sử ca làm việc"
        class="dialog-history"
      >
        <b-row>
          <b-col
            md="6"
            v-for="(item, index) in mData.dataForm.shift"
            :key="index"
            :class="{ hide_div: !item.expiredShift }"
          >
            <el-card class="box-card-information-timekeeping mb-3">
              <b-row>
                <b-col md="12">
                  <el-form-item
                    label="Ca làm"
                    :prop="'shift[' + index + '].shift_id'"
                  >
                    <el-select
                      disabled
                      v-model="item.shift_id"
                      clearable
                      filterable
                      @input="forceUpdateUI"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listCaLamViec"
                        :key="item.id"
                        :label="
                          item.code +
                          ` (${formatDate(
                            item.applied_start_time
                          )} - ${formatDate(item.applied_end_time)})`
                        "
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="12">
                  <el-form-item
                    label="Ngày bắt đầu"
                    :prop="'shift[' + index + '].start_time'"
                  >
                    <el-date-picker
                      disabled
                      v-model="item.start_time"
                      clearable
                      type="date"
                      placeholder=""
                      format="dd/MM/yyyy"
                      @input="forceUpdateUI"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col md="12">
                  <el-form-item
                    label="Ngày kết thúc"
                    :prop="'shift[' + index + '].end_time'"
                  >
                    <el-date-picker
                      disabled
                      v-model="item.end_time"
                      clearable
                      type="date"
                      format="dd/MM/yyyy"
                      @input="forceUpdateUI"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col md="12">
                  <el-form-item
                    label="Không chấm công"
                    :prop="'shift[' + index + '].is_need_checkin'"
                  >
                    <el-switch
                      disabled
                      v-model="item.is_need_checkin"
                      inactive-color="#1597E5"
                      active-color="#DCDFE6"
                      @input="forceUpdateUI"
                    >
                    </el-switch>
                  </el-form-item>
                </b-col>
              </b-row>
            </el-card>
          </b-col>
        </b-row>
      </el-dialog>
    </el-form>
    <!--Disalog show anh CMND -->
    <el-dialog
      :visible.sync="mData.fileUploadOption.dialogVisible"
      :close-on-click-modal="true"
      width="40%"
      top="40px"
      title="Chi tiết"
    >
      <img
        class="dialog-image"
        width="100%"
        :src="mData.fileUploadOption.dialogImageUrl"
        alt=""
      />
    </el-dialog>
    <!-- Dialog thêm mới Social Media Network -->
    <el-dialog
      class="dialog__social-netwotk"
      :title="(typeChangeSocialNetwork == 'create' ? 'Thêm mới' : 'Cập nhật') + ' liên kết xã hội'"
      :visible.sync="visibleDialogSocialNetwork"
      width="500px"
      :before-close="beforeCloseDialogSocialNetwork"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form
          ref="formSocialNetwork"
          :model="mData.dataFormSocialNetWork"
          :rules="mData.validFormSocialNetWork"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <el-form-item label="Loại mạng xã hội" prop="type">
                <el-select
                  v-model="mData.dataFormSocialNetWork.type"
                  filterable
                  clearable
                  @input="forceUpdateUI"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listSocialMediaNetwork"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="URL" prop="url">
                <el-input
                  v-model="mData.dataFormSocialNetWork.url"
                  @change="() => {mData.dataFormSocialNetWork.url = mData.dataFormSocialNetWork.url.trim()}"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12" class="text-center">
              <el-button
                v-if="typeChangeSocialNetwork == 'create'"
                type="primary"
                @click="submitFormSocialNetwork('create')"
              >
                Thêm mới
              </el-button>
              <el-button
                v-if="typeChangeSocialNetwork != 'create'"
                type="primary"
                @click="submitFormSocialNetwork('update')"
              >
                Cập nhật
              </el-button>
            </b-col>
          </b-row>
        </el-form>
      </div>
    </el-dialog>
    <el-image-viewer
      class="dialog__image-viewer"
      v-if="visibleDialogImage"
      :on-close="closeViewer"
      :url-list="[urlImage]"
    />
    <Loading v-if="loading" />
  </div>
</template>

<script>
import ValidService from '../../service/ValidService'
import DataService from '../../service/DataService'
import MethodService from '../../service/MethodService'
import ExtensionService from '../../service/ExtensionService'
import EmployeeModel from '../../views/admin/Employees/EmployeeModel'
import EventBus from '../../service/EventBus'
import ShiftApi from '../../moduleApi/ShiftApi'
import ContractTypeApi from '../../moduleApi/ContractTypeApi'
import BranchApi from '../../moduleApi/BranchApi'
import DepartmentApi from '../../moduleApi/DepartmentApi'
import PositionApi from '../../moduleApi/PositionApi'
import QualificationApi from '../../moduleApi/QualificationApi'
import MajorApi from '../../moduleApi/MajorApi'
import RelationshipApi from '../../moduleApi/RelationshipApi'
import CoefficientSalaryApi from '../../moduleApi/CoefficientSalaryApi'
import RankSalaryApi from '../../moduleApi/RankSalaryApi'
import SubsidiesSalaryTypeApi from '../../moduleApi/SubsidiesSalaryTypeApi'
import EmployeeApi from '../../moduleApi/EmployeeApi'
import EmployeeShiftApi from '../../moduleApi/EmployeeShiftApi'
import EmployeeSignatureApi from '../../moduleApi/EmployeeSignatureApi'
import FileApi from '../../moduleApi/FileApi'
import ProfileApi from '../../moduleApi/ProfileApi'
import OrganizationModelApi from '../../moduleApi/OrganizationModelApi'
import CompanyApi from '../../moduleApi/CompanyApi'
import ElementUIMoney from '../InputComponent/ElementUiMoney'
import * as moment from 'moment'
import Loading from '../Loading'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import ElSelectTree from 'el-select-tree'
export default {
  components: {
    ElementUIMoney,
    Loading,
    ElImageViewer,
    ElSelectTree
  },
  data() {
    return {
      DataService,
      MethodService,
      ValidService,
      showButtonDelete: false,
      showButtonDeleteSignImage: false,
      showButtonDeleteSignFullImage: false,
      showSeniority: true,
      loadPersonalImage: false,
      loadAvatarImage: false,
      loadShift: true,
      loadTimeStart: true,
      loadTimeStartCT: true,
      loadContracType: true,
      checkEnoughSocialNetwork: false,
      visibleDialogSocialNetwork: false,
      typeChangeSocialNetwork: 'create',
      visibleDialogImage: false,
      urlImage: '',
      employeeFullNameInput: '',
      haveLaborContract: false,
      options: {
        locale: 'pt-BR',
        prefix: 'R$',
        suffix: '',
        length: 100,
        precision: 0,
      },
      pickerBirthdayOptions: {
        disabledDate(time) {
          return time.getTime() >= new Date().getTime()
        },
      },
      pickerStartWorkDateOptions: {
        disabledDate(time) {
          return time.getTime() >= new Date().getTime()
        },
      },
      pickerOptions: {},
      loading: false,
      type: '',
      imgUrl: ExtensionService.urlImg,
      activeName2: 'box-card-qualification1',
      activeName3: 'box-card-certificate1',
      activeName4: 'box-card-other-contact-information1',
      activeName5: 'box-card-salary1',
      activeName6: 'box-card-dependent-person1',
      activeName7: 'box-card-sign1',
      activeName8: 'box-card-business',
      mData: {
        haveHistoryShift: false,
        showHistoryShift: false,
        routerParamId: '',
        moduleName: 'EmployeeManager', //requied
        dataForm: MethodService.copyObject(EmployeeModel.dataForm),
        dataFormEmployeeSignature: {},
        dataFormSocialNetWork: {
          type: undefined,
          url: undefined
        },
        validFormSocialNetWork: {
          type: [ValidService.requiredChange],
          url: [ValidService.required]
        },
        validForm: MethodService.copyObject(EmployeeModel.validForm),
        tableRules: MethodService.copyObject(EmployeeModel.tableRules),
        shiftRemove: [],
        listTypeSocialNetwork: [],
        dataDefault: {
          listFeature: MethodService.getListFeatures(),
          anh: '',
          listGioiTinh: DataService.listGioiTinh,
          listCaLamViec: [],
          listNhanVien: [],
          listCompanyScope: [],
          listLoaiHopDong: [],
          listChiNhanh: [],
          listPhongBan: [],
          listChucVu: [],
          listTrangThai: DataService.listTrangThaiLamViec,
          listTrinhDo: [],
          listChuyenNganh: [],
          listHeSoLuong: [],
          listBacLuong: [],
          listMoiQuanHe: [],
          listTroCap: [],
          listAllShift: [],
          listThoiGian: DataService.listThoiGianDiMuonVeSom,
          listShiftValidTime: [],
          listShiftValidTimeCheckDublicate: [],
          listSocialMediaNetwork: DataService.listSocialMediaNetwork,
          listOrganizationModelTree: [],
          arrValidContractIds: [],
        },
        fileUploadOption: {
          dialogImageUrl: '',
          dialogVisible: false,
          Anh: {
            limit: 1,
            accept: '.jpg, .png, .jpeg',
            dialogImageUrl: '',
            dialogVisible: false,
            fileList: [],
          },
          AnhCaNhan: {
            limit: 1,
            accept: '.jpg, .png, .jpeg',
            dialogImageUrl: '',
            dialogVisible: false,
            fileList: [],
          },
          FileHoSo: {
            limit: null,
            accept: '.jpg, .png, .jpeg, .docx, .doc, .xlsx, .xls, .csv, .pdf,',
            dialogImageUrl: '',
            dialogVisible: false,
            fileList: [],
          },
          MatTruocCMND: {
            limit: 1,
            accept: '.jpg, .png, .jpeg',
            dialogImageUrl: '',
            dialogVisible: false,
            fileList: [],
          },
          MatSauCMND: {
            limit: 1,
            accept: '.jpg, .png, .jpeg',
            dialogImageUrl: '',
            dialogVisible: false,
            fileList: [],
          },
          FileChuKy: {
            accept: '.png',
            dialogImageUrl: '',
            listImageSign: []
          },
        },
        isHaveTheChamCong: false,
        employeeId: '',
        timeDiMuon: 0,
        timeVeSom: 0,
      },
      haveAvatar: false,
      userProfile: {},
      currentUser: {},
      companyInfo: {},
      isFormValidated: undefined,
      beforeEmployeeStatus: undefined,
      arrShiftIds: [],
      arrContractTypeIds: [],
      arrPositionIds: [],
      arrBranchIds: [],
      arrDepartmentIds: [],
      arrCoefficientSalaryIds: [],
      arrRankSalaryIds: [],
      arrSubsidiesSalaryTypeIds: [],
      arrQualificationIds: [],
      arrMajorIds: [],
      arrRelationshipIds: []
    }
  },
  methods: {
    validateFieldMethod(prop) {
      this.$refs['myProfileForm'].validateField(prop)
    },
    syncEmployeeFullNameInput() {
      const nameInfo = this.mData.dataForm.administrative_info.name || {}
      this.employeeFullNameInput = nameInfo.full_name || [nameInfo.last_name, nameInfo.first_name].filter(Boolean).join(' ')
    },
    setEmployeeFullNameFields(value) {
      const fullName = value || ''
      const nameParts = fullName ? fullName.split(' ') : []
      const firstName = nameParts.length ? nameParts[nameParts.length - 1] : ''
      const lastName = nameParts.length > 1 ? nameParts.slice(0, -1).join(' ') : ''
      this.mData.dataForm.administrative_info.name.full_name = fullName
      this.mData.dataForm.administrative_info.name.first_name = firstName
      this.mData.dataForm.administrative_info.name.last_name = lastName
    },
    handleEmployeeFullNameInput(value) {
      this.setEmployeeFullNameFields(value)
      this.forceUpdateUI()
    },
    handleEmployeeFullNameChange(value) {
      this.employeeFullNameInput = MethodService.trimSpace((value || '').trim())
      this.setEmployeeFullNameFields(this.employeeFullNameInput)
      this.forceUpdateUI()
    },
    async fn_getListOrganizationModelTree() {
      const organizationApiRes = await OrganizationModelApi.list({
        limit: 9999,
      })
      if (organizationApiRes.result) {
        let result = organizationApiRes.result
        let treeList = []
        // Get all parent
        let parents = result.filter((r) => r.parent_id == null)
        if (parents != null && parents.length > 0) {
          parents.forEach((organization1) => {
            let obj = {
              id: organization1.id,
              value: organization1.id,
              label: organization1.name
                ? organization1.name
                : 'Tổ chức không xác định',
              children: [],
            }
            // Get child of parent
            const childs = result.filter((r) => r.parent_id == obj.id)
            if (childs != null && childs.length > 0) {
              childs.forEach((element) => {
                obj.children.push({
                  id: element.id,
                  value: element.id,
                  label: element.name ? element.name : 'Tổ chức không xác định',
                  children: this.fn_getTreeByRecursion(element, result),
                })
              })
            }
            treeList.push(obj)
          })
        }
        this.mData.dataDefault.listOrganizationModelTree = treeList
      }
    },

    fn_getTreeByRecursion(child, rootArr) {
      let childrenArr = rootArr.filter((r) => r.parent_id == child.id)
      if (!childrenArr || childrenArr.length == 0) return []
      let root = childrenArr.map((organization1) => {
        let obj = {
          id: organization1.id,
          value: organization1.id,
          label: organization1.name ? organization1.name : 'Không xác định',
          children: [],
        }
        obj.children = this.fn_getTreeByRecursion(organization1, rootArr)
        return obj
      })
      return root
    },

    mouseOver(event,index,type){
      if(type == 'avatarImage'){
        //Nếu không có ảnh thì không hiển thị
        if (!this.mData.dataForm.image_id) return
        this.showButtonDelete = event
      } else {
        this.mData.fileUploadOption.FileChuKy.listImageSign[index].showButtonDelete = event
      }
    },
    fn_canEditSignature() {
      return (
        this.mData.viewMode != 'detail' &&
        this.mData.viewMode != 'employeeInfo' &&
        this.mData.dataDefault.listFeature.includes('FT103') &&
        this.mData.dataDefault.listFeature.includes('FT104')
      )
    },
    fn_getFirstSignImage() {
      const listImageSign = this.mData.fileUploadOption.FileChuKy.listImageSign || []
      return listImageSign.length > 0 ? listImageSign[0] : null
    },
    removePersonalImage(){
      this.loadPersonalImage = true
      this.mData.dataForm.PersonalImageUrl = 'img/demo.png'
      this.mData.dataForm.image_id = null
      this.showButtonDelete = false
      this.loadPersonalImage = false
    },
    checkStatusVsGender(type){
      if (type == 'status') {
        if (this.mData.dataForm.status == 'NGHI_SINH') {
          this.mData.dataDefault.listGioiTinh = [
            {
              value: 0,
              label: 'Nữ'
            },
            {
              value: 2,
              label: 'Khác'
            }
          ]
          if (this.mData.dataForm.administrative_info.gender == 1) {
            this.mData.dataForm.administrative_info.gender = undefined
          }
        } else {
          this.mData.dataDefault.listGioiTinh = DataService.listGioiTinh
        }
      } else {
        if (this.mData.dataForm.administrative_info.gender == 1) {
          this.mData.dataDefault.listTrangThai = [
            {
              value: 'DANG_LAM_VIEC',
              label: 'Đang làm việc'
            },
            {
              value: 'DA_NGHI',
              label: 'Đã nghỉ'
            }
          ]
          if (this.mData.dataForm.status == 'NGHI_SINH') {
            this.mData.dataForm.status = 'DANG_LAM_VIEC'
          }

        } else {
          this.mData.dataDefault.listTrangThai = DataService.listTrangThaiLamViec
        }
      }
    },
    formatDate(value) {
      return MethodService.formatDate(value, 'date')
    },
    fn_getDirectManagerLabel(employee) {
      if (!employee) return ''
      const fullName =
        employee.name ||
        (employee.administrative_info &&
        employee.administrative_info.name &&
        employee.administrative_info.name.full_name
          ? employee.administrative_info.name.full_name
          : '') ||
        employee.full_name ||
        employee.employee_no ||
        ''
      return employee.employee_no ? `${employee.employee_no} - ${fullName}` : fullName
    },
    fn_mapDirectManagerOptions(employees) {
      return [...new Map(
        (employees || [])
          .map((item) => {
            const employee = item && item.e ? item.e : item
            if (!employee || !employee.id) return null
            return [
              employee.id,
              {
                ...employee,
                name: this.fn_getDirectManagerLabel(employee),
              }
            ]
          })
          .filter(Boolean)
      ).values()]
    },
    async fn_getListDirectManagerOptions() {
      const companyId = this.mData.dataForm.company_id || this.userProfile.company_id
      const employeeId =
        this.mData.dataForm.id ||
        this.mData.employeeId ||
        this.$router.currentRoute.params.id ||
        (this.currentUser && this.currentUser.id ? this.currentUser.id : undefined)

      if (!companyId || !employeeId) {
        this.mData.dataDefault.listNhanVien = []
        return
      }

      try {
        const directManagerRes = await EmployeeApi.GetDirectManagerCandidates({
          employee_id: employeeId,
          company_id: companyId,
          feature_code: 'FT1006',
          approver_type: 'QLTT',
          limit: 500,
        })
        this.mData.dataDefault.listNhanVien = this.fn_mapDirectManagerOptions(
          directManagerRes && directManagerRes.result
            ? directManagerRes.result.employees
            : []
        )
        return
      } catch (error) {
        console.error('Load direct manager candidates failed', error)
        this.mData.dataDefault.listNhanVien = []
      }
    },
    async fn_innitDataDefault() {
      this.userProfile = MethodService.getUserProfile()
      this.currentUser = MethodService.getCurrentUser()
      this.companyInfo = MethodService.getCompanyInfo()
      if (!this.mData.dataForm.company_id) {
        this.mData.dataForm.company_id = this.userProfile.company_id
      }
      let currentTime = moment(new Date()).format('yyyy-MM-DD')

      const companyScopeReq = CompanyApi.list({limit: 9999999,}, true)
      const shiftApiReq = ShiftApi.list({
        filters: this.arrShiftIds.length > 0 ? `applied_end_time>=${currentTime}|id:in:${this.arrShiftIds}` : `applied_end_time>=${currentTime}`,
        limit: 999999,
      })
      const contractTypeApiReq = ContractTypeApi.list({
        filters: this.arrContractTypeIds.length > 0 ? `disabled!=true|id:in:${this.arrContractTypeIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const branchApiReq = BranchApi.list({
        filters: this.arrBranchIds.length > 0 ? `disabled!=true|id:in:${this.arrBranchIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const departmentApiReq = DepartmentApi.list({
        filters: this.arrDepartmentIds.length > 0 ? `disabled!=true|id:in:${this.arrDepartmentIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const positionApiReq = PositionApi.list({
        filters: this.arrPositionIds.length > 0 ? `disabled!=true|id:in:${this.arrPositionIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const qualificationApiReq = QualificationApi.list({
        filters: this.arrQualificationIds.length > 0 ? `disabled!=true|id:in:${this.arrQualificationIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const majorApiReq = MajorApi.list({
        filters: this.arrMajorIds.length > 0 ? `disabled!=true|id:in:${this.arrMajorIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const relationshipApReq = RelationshipApi.list({
        filters: this.arrRelationshipIds.length > 0 ? `disabled!=true|id:in:${this.arrRelationshipIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const coefficientSalaryApiReq = CoefficientSalaryApi.list({
        filters: this.arrCoefficientSalaryIds.length > 0 ? `disabled!=true|id:in:${this.arrCoefficientSalaryIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const rankSalaryApiReq = RankSalaryApi.list({
        filters: this.arrRankSalaryIds.length > 0 ? `disabled!=true|id:in:${this.arrRankSalaryIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const subsidiesSalaryTypeApiReq = SubsidiesSalaryTypeApi.list({
        filters: this.arrSubsidiesSalaryTypeIds.length > 0 ? `disabled!=true|id:in:${this.arrSubsidiesSalaryTypeIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)

      const companyScopeRes = await companyScopeReq
      const shiftApiRes = await shiftApiReq
      const contractTypeApiRes = await contractTypeApiReq
      const branchApiRes = await branchApiReq
      const departmentApiRes = await departmentApiReq
      const positionApiRes = await positionApiReq
      const qualificationApiRes = await qualificationApiReq
      const majorApiRes = await majorApiReq
      const relationshipApRes = await relationshipApReq
      const coefficientSalaryApiRes = await coefficientSalaryApiReq
      const rankSalaryApiRes = await rankSalaryApiReq
      const subsidiesSalaryTypeApiRes = await subsidiesSalaryTypeApiReq

      this.mData.dataDefault.listCompanyScope = Array.isArray(companyScopeRes.result) ? companyScopeRes.result : [this.companyInfo]
      this.mData.dataDefault.listCaLamViec = shiftApiRes.result
      this.mData.dataDefault.listLoaiHopDong = contractTypeApiRes.result
      this.mData.dataDefault.listChiNhanh = branchApiRes.result
      this.mData.dataDefault.listPhongBan = departmentApiRes.result
      this.mData.dataDefault.listChucVu = positionApiRes.result
      this.mData.dataDefault.listTrinhDo = qualificationApiRes.result
      this.mData.dataDefault.listChuyenNganh = majorApiRes.result
      this.mData.dataDefault.listMoiQuanHe = relationshipApRes.result
      this.mData.dataDefault.listHeSoLuong = coefficientSalaryApiRes.result
      this.mData.dataDefault.listBacLuong = rankSalaryApiRes.result
      this.mData.dataDefault.listTroCap = subsidiesSalaryTypeApiRes.result
      this.mData.dataDefault.arrValidContractIds = MethodService.findListItemDifferent(this.mData.dataDefault.listLoaiHopDong, 'id')
      await this.fn_getListDirectManagerOptions()
    },
    fn_selectedCompanyInfo() {
      const selectedCompanyId = this.mData.dataForm.company_id || this.userProfile.company_id
      return this.mData.dataDefault.listCompanyScope.find(item => item.id == selectedCompanyId) || this.companyInfo || {}
    },
    fn_selectedCompanyPrefix() {
      const company = this.fn_selectedCompanyInfo()
      const abbreviation = company.name && (company.name.abbreviation_name || company.name.Abbreviation_name)
      return abbreviation || (this.companyInfo.name && this.companyInfo.name.abbreviation_name) || ''
    },
    fn_shouldPersistShift(shift) {
      if (!shift) return false
      if (shift.shift_id) return true
      return shift.is_need_checkin !== false
    },
    fn_activeShiftIndex() {
      const index = (this.mData.dataForm.shift || []).findIndex((shift) => !shift.expiredShift)
      return index >= 0 ? index : 0
    },
    fn_activeShiftProp() {
      return `shift[${this.fn_activeShiftIndex()}].shift_id`
    },
    fn_activeShiftRules() {
      const index = this.fn_activeShiftIndex()
      const shift = (this.mData.dataForm.shift || [])[index]
      if (shift && shift.is_need_checkin === false) return []

      const shiftRules = this.mData.validForm.shift && this.mData.validForm.shift[index]
      return shiftRules && shiftRules.shift_id
        ? shiftRules.shift_id
        : [ValidService.required]
    },
    fn_canEditEmployeeBaseInfo() {
      return this.mData.dataDefault.listFeature.includes('FT103') &&
        this.mData.dataDefault.listFeature.includes('FT104')
    },
    fn_canTransferEmployeeCompany() {
      return this.mData.dataDefault.listFeature.includes('FT2307')
    },
    fn_isCompanySelectDisabled() {
      if (this.mData.viewMode == 'detail' || this.mData.viewMode == 'employeeInfo') return true
      if (!this.fn_canEditEmployeeBaseInfo()) return true
      if (this.mData.viewMode == 'update') return !this.fn_canTransferEmployeeCompany()
      return false
    },
    fn_companyLabel(item) {
      if (!item) return ''
      const name = item.name && (item.name.name_vi || item.name.Name_vi) ? (item.name.name_vi || item.name.Name_vi) : item.name
      const prefix = item.level ? `${'— '.repeat(item.level)}` : ''
      return `${prefix}${name || item.id}`
    },
    clearAllValidateStatus() {
      if (this.$refs['myProfileForm']) this.$refs['myProfileForm'].clearValidate()
    },
    fn_getEmployeeStartDateForSeniority() {
      if (this.mData.dataForm.start_work_date) {
        return this.mData.dataForm.start_work_date
      }
      const startDates = (this.mData.dataForm.job_info || [])
        .filter(item => item && item.start_date)
        .map(item => item.start_date)
        .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
      return startDates[0]
    },
    fn_updateSeniority() {
      this.calculateSeniority(this.fn_getEmployeeStartDateForSeniority())
    },
    calculateSeniority(date){
      this.showSeniority = false
      if (!date) {
        this.mData.dataForm.seniority = 0
      } else {
        let dateNow = moment(new Date())
        let dateTimeStart = moment(date)
        this.mData.dataForm.seniority = Math.floor(dateNow.diff(dateTimeStart, 'years', true) < 0 ? 0 : dateNow.diff(dateTimeStart, 'years', true))
      }
      this.showSeniority = true
    },
    checkHaveLaborContract() {
      let validJobInfo = this.mData.dataForm.job_info.find(job => {
        return ((new Date(job.start_date).getTime() <= new Date().getTime() && !job.end_date) ||
        (new Date(job.start_date).getTime() <= new Date().getTime() && new Date(job.end_date).getTime() > new Date().getTime())) &&
        job.kind_of_contract == 'LABOR'
      })
      if (validJobInfo) {
        this.haveLaborContract = true
        this.$set(this.mData.validForm, 'insurance_book_number', [ValidService.checkNumber, ValidService.checkMaxLength(20)])
        this.$set(this.mData.validForm.salary, 'insurance_salary', [])
        this.$set(this.mData.validForm.salary, 'subsidies_salary', [])
        this.mData.dataForm.salary.subsidies_salary.forEach(subsidies_salary => {
          this.mData.validForm.salary.subsidies_salary.push(EmployeeModel.validSubsidiesSalary)
        })
        this.activeName5 = 'box-card-salary'
        this.clearAllValidateStatus()
      } else {
        this.haveLaborContract = false
        let arrayNull = new Array()
        this.$set(this.mData.validForm, 'insurance_book_number', arrayNull)
        this.$set(this.mData.validForm.salary, 'insurance_salary', arrayNull)
        this.$set(this.mData.validForm.salary, 'subsidies_salary', arrayNull)
        this.mData.dataForm.salary.subsidies_salary.forEach(subsidies_salary => {
          this.mData.validForm.salary.subsidies_salary.push({
            subsidies_salary_type_id: arrayNull,
            value: arrayNull
          })
        })
        this.clearAllValidateStatus()
      }
    },
    async fn_submit(type) {
      this.$refs['myProfileForm'].validate(async (valid,objectError) => {
        if (valid) {
          if (!this.mData.dataForm.administrative_info.avatar_id) {
            window.toastr.error('Vui lòng chọn ảnh!')
            return
          }

          //Trim khoảng trắng các ô input
          if (
            this.mData.dataForm.administrative_info.name.first_name &&
            this.mData.dataForm.administrative_info.name.last_name
          ) {
            this.mData.dataForm.administrative_info.name.full_name =
              this.mData.dataForm.administrative_info.name.last_name +
              ' ' +
              this.mData.dataForm.administrative_info.name.first_name
          }

          if (this.mData.dataForm.administrative_info.address) {
            this.mData.dataForm.administrative_info.address =
              this.mData.dataForm.administrative_info.address.trim()
          }

          if (
            this.mData.dataForm.qualification &&
            this.mData.dataForm.qualification.length > 0
          ) {
            this.mData.dataForm.qualification.forEach((e) => {
              if (e.issued_by) {
                e.issued_by = e.issued_by.trim()
              }
              if (e.note) {
                e.note = e.note.trim()
              }
            })
          }

          if (
            this.mData.dataForm.certificate &&
            this.mData.dataForm.certificate.length > 0
          ) {
            this.mData.dataForm.certificate.forEach((e) => {
              if (e.name) {
                e.name = e.name.trim()
              }
              if (e.issued_by) {
                e.issued_by = e.issued_by.trim()
              }
              if (e.note) {
                e.note = e.note.trim()
              }
            })
          }

          if (
            this.mData.dataForm.other_contact_info &&
            this.mData.dataForm.other_contact_info.length > 0
          ) {
            this.mData.dataForm.other_contact_info.forEach((e) => {
              if (e.full_name) {
                e.full_name = e.full_name.trim()
              }
              if (e.address) {
                e.address = e.address.trim()
              }
            })
          }

          if (this.mData.dataForm.salary.payment_method) {
            this.mData.dataForm.salary.payment_method =
              this.mData.dataForm.salary.payment_method.trim()
          }

          if (this.mData.dataForm.salary.bank_name) {
            this.mData.dataForm.salary.bank_name =
              this.mData.dataForm.salary.bank_name.trim()
          }

          if (this.mData.dataForm.salary.bank_branch) {
            this.mData.dataForm.salary.bank_branch =
              this.mData.dataForm.salary.bank_branch.trim()
          }

          if (
            this.mData.dataForm.certificate &&
            this.mData.dataForm.certificate.length > 0
          ) {
            this.mData.dataForm.certificate.forEach((e) => {
              if (e.name) {
                e.name = e.name.trim()
              }
              if (e.issued_by) {
                e.issued_by = e.issued_by.trim()
              }
              if (e.note) {
                e.note = e.note.trim()
              }
            })
          }

          if (
            this.mData.dataForm.dependent_person_info &&
            this.mData.dataForm.dependent_person_info.length > 0
          ) {
            this.mData.dataForm.dependent_person_info.forEach((e) => {
              if (e.full_name) {
                e.full_name = e.full_name.trim()
              }
            })
          }
          //End trim khoảng trắng các ô input

          //Check ngày kết thúc lớn hơn ngày bắt đầu
          if (
            this.mData.dataForm.shift &&
            this.mData.dataForm.shift.length > 0
          ) {
            let check = true
            this.mData.dataForm.shift.forEach((e, index) => {
              if (
                e.end_time &&
                new Date(e.end_time).getTime() > new Date().getTime()
              ) {
                if (
                  new Date(e.start_time).getTime() >
                  new Date(e.end_time).getTime()
                ) {
                  window.toastr.warning(
                    'Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu'
                  )
                  this.$refs[`shift[${index}].end_time`].focus()
                  check = false
                  return
                }
              }
            })
            if (!check) {
              return
            }
          }

          if (
            this.mData.dataForm.job_info &&
            this.mData.dataForm.job_info.length > 0
          ) {
            let check = true
            this.mData.dataForm.job_info.forEach((e, index) => {
              if (e.end_date) {
                if (
                  new Date(e.start_date).getTime() >
                  new Date(e.end_date).getTime()
                ) {
                  window.toastr.warning(
                    'Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu'
                  )
                  this.$refs[`job_info[${index}].end_date`].focus()
                  check = false
                  return
                }
              }
            })
            if (!check) {
              return
            }
          }

          if (
            this.mData.dataForm.dependent_person_info &&
            this.mData.dataForm.dependent_person_info.length > 0
          ) {
            let check = true
            this.mData.dataForm.dependent_person_info.forEach((e, index) => {
              if (e.expired_date) {
                if (
                  new Date(e.registered_date).getTime() >
                  new Date(e.expired_date).getTime()
                ) {
                  window.toastr.warning(
                    'Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu'
                  )
                  this.$refs[`dependent_person_info[${index}].expired_date`].focus()
                  check = false
                  return
                }
              }
            })
            if (!check) {
              return
            }
          }
          //End check
          //Check phải có ít nhất 1 ca lầm viêc còn hiệu lực hoặc thông tin công việc
          let submitShiftData = MethodService.copyObject(this.mData.dataForm.shift || [])
          const activeJobInfoIndex = this.mData.dataForm.job_info.findIndex((job) => !!job)
          let activeShiftIndex = submitShiftData.findIndex((shift) => !shift.expiredShift)
          if (activeJobInfoIndex >= 0) {
            if (activeShiftIndex < 0) {
              submitShiftData.push(MethodService.copyObject(EmployeeModel.dataShift))
              activeShiftIndex = submitShiftData.length - 1
            }
            submitShiftData[activeShiftIndex].start_time =
              this.mData.dataForm.job_info[activeJobInfoIndex].start_date || undefined
            if (submitShiftData[activeShiftIndex].is_need_checkin == undefined) {
              submitShiftData[activeShiftIndex].is_need_checkin = true
            }
          }
          if (
            MethodService.getValidShiftInfo(submitShiftData).length == 0 &&
            MethodService.getFutureShiftInfo(submitShiftData).length == 0
          ) {
            window.toastr.warning('Nhân viên phải có ít nhất 1 ca làm việc còn hiệu lực!')
            return
          }
          if (
            MethodService.getValidJobInfo(this.mData.dataForm.job_info, this.mData.dataDefault.arrValidContractIds).length == 0 &&
            MethodService.getFutureJobInfo(this.mData.dataForm.job_info, this.mData.dataDefault.arrValidContractIds).length == 0
          ) {
            window.toastr.warning('Nhân viên phải có ít nhất 1 thông tin công việc còn hiệu lực!')
            return
          }
          //End check
          let checkFail = false
          //Check chọn ca làm việc và ngày bắt đầu
          submitShiftData.forEach((item, index) => {
            if (item.is_need_checkin !== false && !item.shift_id) {
              window.toastr.error('Chưa chọn ca làm việc thứ ' + (index + 1))
              if (this.$refs[`shift[${index}].shift_id`]) {
                this.$refs[`shift[${index}].shift_id`].focus()
              }
              checkFail = true
            } else if (!item.start_time) {
              window.toastr.error('Chưa chọn ngày bắt đầu thứ ' + (index + 1))
              if (this.$refs[`job_info[${index}].start_date`]) this.$refs[`job_info[${index}].start_date`].focus()
              checkFail = true
            }
          })
          if (checkFail) return
          this.mData.dataForm.shift = submitShiftData
          //End check
          //check trường tiền về undefined
          if (this.mData.dataForm.salary.insurance_salary == '') {
            this.mData.dataForm.salary.insurance_salary = undefined
          }
          //Check những trợ cấp không tồn tại
          if (
            this.mData.dataForm.salary &&
            this.mData.dataForm.salary.subsidies_salary &&
            this.mData.dataForm.salary.subsidies_salary.length > 0
          ) {
            this.mData.dataForm.salary.subsidies_salary.forEach((e, i) => {
              if (!e.subsidies_salary_type_id && !e.value) {
                e.subsidies_salary_type_id = undefined
                e.value = undefined
              } else if (!e.subsidies_salary_type_id && e.value) {
                e.subsidies_salary_type_id = undefined
              } else if (e.subsidies_salary_type_id && (!e.value || e.value == '')) {
                e.value = undefined
              }
            })
          }
          if (!this.mData.dataForm.company_id) {
            this.mData.dataForm.company_id = this.userProfile.company_id
          }
          let data = MethodService.copyObject(this.mData.dataForm)
          delete data.seniority
          if (!data.salary.insurance_salary) {
            data.salary.insurance_salary = null
          }
          data.employee_no = this.mData.dataForm.employee_no.toUpperCase()
          // data.card_no = this.mData.dataForm.employee_no.toUpperCase()
          let dataProfile = {
            id: this.mData.dataForm.id,
            company_id: data.company_id,
            name: this.mData.dataForm.administrative_info.name,
            birthday: this.mData.dataForm.administrative_info.birthday,
            gender: this.mData.dataForm.administrative_info.gender,
            phone_number: this.mData.dataForm.administrative_info.phone_number,
            email: this.mData.dataForm.administrative_info.email,
          }
          let dataEmployeeSignature
          if (this.mData.dataForm.image_ids && this.mData.dataForm.image_ids.length > 0) {
            dataEmployeeSignature = {
              image_ids: this.mData.dataForm.image_ids
            }
          } else {
            dataEmployeeSignature = {
              image_ids: []
            }
          }
          console.log('dataEmployeeSignature', dataEmployeeSignature)
          // return
          data.card_no = data.employee_no
          // return
          if (type == 'create') {
            let accountNotHaveCompany = this.mData.dataForm.account
            try {
              data.account =
                this.fn_selectedCompanyPrefix().toLowerCase() +
                '_' +
                this.mData.dataForm.account.toLowerCase()
              let res = await EmployeeApi.create(data)
              this.mData.dataForm.shift.forEach((item) => {
                item.employee_id = res.result
                item.company_id = data.company_id
              })
              let dataEmployeeShift = this.mData.dataForm.shift.filter(item =>
                this.fn_shouldPersistShift(item)
              )

              if (dataEmployeeShift.length > 0) {
                await EmployeeShiftApi.createMany(dataEmployeeShift)
              }
              dataEmployeeSignature.employee_id = res.result
              if (dataEmployeeSignature) {
                this.updateEmployeeSignature(dataEmployeeSignature)
              }
              window.toastr.success('Thêm mới nhân viên thành công')
              window.toastr.success('Mật khẩu đã được gửi tới email người dùng')
              this.emitGlobalDataChange()
              this.fn_resetForm()
              this.mData.dataForm.avatarUrl = ''
              this.mData.dataForm.PersonalImageUrl = ''
              this.mData.dataForm.image_ids = []
              this.mData.fileUploadOption.FileChuKy.listImageSign = []
              let dataAdd = MethodService.copyObject(EmployeeModel.dataSubsidiesSalary)
              dataAdd.key = Math.random().toString(36).substring(2)
              this.mData.dataForm.salary.subsidies_salary.push(dataAdd)
            } catch (error) {
              window.toastr.error(error.detail)
              this.mData.dataForm.account = accountNotHaveCompany
            }
          }
          if (type == 'update') {
            let currentDate = new Date()
            try {
              if (this.beforeEmployeeStatus != 'DA_NGHI' && data.status == 'DA_NGHI') {
                data.start_work_date = null
                data.job_info.forEach(e => {
                  if (new Date(e.start_date).getTime() < new Date().getTime() && (e.end_date == undefined || (new Date(e.end_date).getTime() > new Date().getTime()))) {
                    e.end_date = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59)
                  }
                  if (new Date(e.start_date).getTime() > new Date().getTime() && (e.end_date == undefined || (new Date(e.end_date).getTime() > new Date().getTime()))) {
                    e.start_date = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0)
                    e.end_date = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0)
                  }
                })
              }
              if (this.beforeEmployeeStatus == 'DA_NGHI' && data.status == 'DANG_LAM_VIEC') {
                data.start_work_date = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0)
              }
              await EmployeeApi.update(data)
              await ProfileApi.update(dataProfile)
              this.mData.dataForm.shift.forEach(async (items) => {
                if (!this.fn_shouldPersistShift(items)) return
                if (items.id) {
                  if (data.status == 'DA_NGHI') {
                    if (new Date(items.start_time).getTime() < new Date().getTime() && (items.end_time == undefined || (new Date(items.end_time).getTime() > new Date().getTime()))) {
                      items.end_time = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59)
                    }
                    if (new Date(items.start_time).getTime() > new Date().getTime() && (items.end_time == undefined || (new Date(items.end_time).getTime() > new Date().getTime()))) {
                      items.start_time = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0)
                      items.end_time = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0)
                    }
                  }
                  if (items.expiredShift === true) return
                  await EmployeeShiftApi.update(items)
                } else {
                  items.employee_id = this.$router.currentRoute.params.id
                  items.company_id = data.company_id
                  if (data.status == 'DA_NGHI') {
                    if (new Date(items.start_time).getTime() < new Date().getTime() && (items.end_time == undefined || (new Date(items.end_time).getTime() > new Date().getTime()))) {
                      items.end_time = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59)
                    }
                    if (new Date(items.start_time).getTime() > new Date().getTime() && (items.end_time == undefined || (new Date(items.end_time).getTime() > new Date().getTime()))) {
                      items.start_time = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0)
                      items.end_time = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0)
                    }
                  }
                  await EmployeeShiftApi.create(items)
                }
              })

              dataEmployeeSignature.employee_id = this.$router.currentRoute.params.id
              if (dataEmployeeSignature) {
                this.updateEmployeeSignature(dataEmployeeSignature)
              }
              this.emitGlobalDataChange()
              if (this.mData.shiftRemove.length > 0) {
                this.mData.shiftRemove.forEach(async (item) => {
                  if (item.id) {
                    await EmployeeShiftApi.delete(item.id)
                  }
                })
              }
              setTimeout(() => {
                this.fn_getDataById(this.$router.currentRoute.params.id)
                window.toastr.success('Cập nhật nhân viên thành công')
                let eventName1 = 'click_HSCN_Name'
                EventBus.$emit(eventName1, {})
              }, 500)
            } catch (error) {
              window.toastr.error(error.detail)
            }
          }
        } else {
          let arrKey = Object.keys(objectError || {})
          if (arrKey.length > 0) {
            const fieldNameMap = {
              'avatar_id': 'Ảnh chấm công',
              'employee_no': 'Mã nhân viên',
              'first_name': 'Tên nhân viên',
              'last_name': 'Họ và tên đệm',
              'full_name': 'Họ và tên',
              'gender': 'Giới tính',
              'email': 'Email cá nhân',
              'birthday': 'Ngày sinh',
              'phone_number': 'Số điện thoại',
              'address': 'Địa chỉ',
              'identity_card_number': 'CCCD/CMND/Hộ chiếu',
              'account': 'Tài khoản',
              'company_id': 'Công ty',
              'status': 'Trạng thái',
              'branch_id': 'Chi nhánh',
              'department_id': 'Phòng ban',
              'position_id': 'Chức vụ',
              'direct_manager_id': 'Quản lý trực tiếp',
              'insurance_book_number': 'Số sổ BHXH',
              'insurance_salary': 'Lương đóng bảo hiểm',
              'shift_id': 'Ca làm việc',
              'contract_type_id': 'Loại hợp đồng',
              'start_date': 'Ngày bắt đầu',
              'end_date': 'Ngày kết thúc',
              'kind_of_contract': 'Hình thức hợp đồng',
              'subsidies_salary_type_id': 'Loại phụ cấp',
              'value': 'Mức phụ cấp',

              'administrative_info.avatar_id': 'Ảnh chấm công',
              'administrative_info.employee_no': 'Mã nhân viên',
              'administrative_info.name.first_name': 'Tên nhân viên',
              'administrative_info.name.last_name': 'Họ và tên đệm',
              'administrative_info.name.full_name': 'Họ và tên',
              'administrative_info.gender': 'Giới tính',
              'administrative_info.email': 'Email cá nhân',
              'administrative_info.birthday': 'Ngày sinh',
              'administrative_info.phone_number': 'Số điện thoại',
              'administrative_info.address': 'Địa chỉ',
              'administrative_info.identity_card_number': 'CCCD/CMND/Hộ chiếu',
              'salary.insurance_salary': 'Lương đóng bảo hiểm',
            }

            const firstKey = arrKey[0]
            const cleanKey = firstKey.replace(/\[\d+\]/g, '').split('.').pop()
            const firstFieldName = fieldNameMap[firstKey] || fieldNameMap[cleanKey] || cleanKey
            const actionText = ['gender', 'company_id', 'branch_id', 'department_id', 'position_id', 'status', 'shift_id', 'contract_type_id', 'avatar_id'].some(k => firstKey.includes(k)) ? 'chọn' : 'nhập'

            window.toastr.error(`Vui lòng ${actionText} ${firstFieldName}!`)

            if (this.$refs[arrKey[0]] && this.$refs[arrKey[0]].length > 0) {
              this.$refs[arrKey[0]][0].$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
              setTimeout(() => {
                this.$refs[arrKey[0]][0].focus()
              }, 500)
            } else {
              setTimeout(() => {
                try {
                  this.$refs[arrKey[0]].$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
                  if (this.$refs[arrKey[0]]) this.$refs[arrKey[0]].focus()
                } catch (error) {
                  console.log('error', error)
                }
              }, 500)
            }
          } else {
            window.toastr.error('Vui lòng điền đầy đủ các thông tin bắt buộc (*)!')
          }
          MethodService.stopLadda()
          return false
        }
      })
    },
    async updateEmployeeSignature(data) {
      data.company_id = this.mData.dataForm.company_id || this.userProfile.company_id
      if(this.mData.dataFormEmployeeSignature.id) {
        //Thực hiện update chữ ký
        data.id = this.mData.dataFormEmployeeSignature.id
        await EmployeeSignatureApi.update(data)
      } else {
        //Thực hiện thêm mới chữ ký
        await EmployeeSignatureApi.create(data)
      }
    },
    async fn_getDataById(id) {
      this.loading = true
      try {
        this.mData.dataDefault.listShiftValidTime = []
        this.mData.dataDefault.listSocialMediaNetwork = DataService.listSocialMediaNetwork
        this.checkEnoughSocialNetwork = false
        this.mData.haveHistoryShift = false
        this.mData.shiftRemove = []
        this.mData.fileUploadOption.Anh.fileList = []
        this.mData.fileUploadOption.FileHoSo.fileList = []
        this.mData.fileUploadOption.MatTruocCMND.fileList = []
        this.mData.fileUploadOption.MatSauCMND.fileList = []
        this.mData.fileUploadOption.FileChuKy.listImageSign = []
        this.mData.validForm = MethodService.copyObject(EmployeeModel.validForm)
        let employeeApiRes = await EmployeeApi.findById(id)
        let employeeShiftApiRes = await EmployeeShiftApi.list(
          {
            filters: 'employee_id=' + id,
          },
          true
        )
        let employeeSignatureApiRes = await EmployeeSignatureApi.list({
          filters: 'employee_id=' + id,
        }, true)
        if (employeeApiRes.result) {
        this.beforeEmployeeStatus = employeeApiRes.result.status
        const defaultEmployeeForm = MethodService.copyObject(EmployeeModel.dataForm)
        this.mData.dataForm = Object.assign(defaultEmployeeForm, employeeApiRes.result)
        this.mData.dataForm.administrative_info = Object.assign(
          defaultEmployeeForm.administrative_info,
          this.mData.dataForm.administrative_info || {}
        )
        this.syncEmployeeFullNameInput()
        this.mData.dataForm.salary = Object.assign(
          defaultEmployeeForm.salary,
          this.mData.dataForm.salary || {}
        )
        this.mData.dataForm.job_info = Array.isArray(this.mData.dataForm.job_info) ? this.mData.dataForm.job_info : []
        this.mData.dataForm.qualification = Array.isArray(this.mData.dataForm.qualification) ? this.mData.dataForm.qualification : []
        this.mData.dataForm.certificate = Array.isArray(this.mData.dataForm.certificate) ? this.mData.dataForm.certificate : []
        this.mData.dataForm.other_contact_info = Array.isArray(this.mData.dataForm.other_contact_info) ? this.mData.dataForm.other_contact_info : []
        this.mData.dataForm.dependent_person_info = Array.isArray(this.mData.dataForm.dependent_person_info) ? this.mData.dataForm.dependent_person_info : []
        this.mData.dataForm.file_ids = Array.isArray(this.mData.dataForm.file_ids) ? this.mData.dataForm.file_ids : []
        this.mData.dataForm.social_networks = Array.isArray(this.mData.dataForm.social_networks) ? this.mData.dataForm.social_networks : []
        this.mData.dataForm.image_ids = Array.isArray(this.mData.dataForm.image_ids) ? this.mData.dataForm.image_ids : []
        this.mData.dataForm.salary.subsidies_salary = Array.isArray(this.mData.dataForm.salary.subsidies_salary) ? this.mData.dataForm.salary.subsidies_salary : []
        this.fn_updateSeniority()
        if (this.mData.dataForm.administrative_info.avatar_id) {
          let data = {
            id: this.mData.dataForm.administrative_info.avatar_id,
            name: this.mData.dataForm.administrative_info.avatar_id,
            url:
              ExtensionService.urlImg +
              this.mData.dataForm.administrative_info.avatar_id,
          }
          this.mData.dataForm.avatarUrl = data.url
          this.mData.fileUploadOption.Anh.fileList.push(data)
          this.haveAvatar = true
        } else {
          this.mData.dataForm.avatarUrl = 'img/demo.png'
        }

        if (this.mData.dataForm.image_id) {
          let data = {
            id: this.mData.dataForm.image_id,
            name: this.mData.dataForm.image_id,
            url:
              ExtensionService.urlImg +
              this.mData.dataForm.image_id,
          }
          this.mData.dataForm.PersonalImageUrl = data.url
          this.mData.fileUploadOption.AnhCaNhan.fileList.push(data)
          this.haveAvatar = true
        } else {
          this.mData.dataForm.PersonalImageUrl = 'img/demo.png'
        }

        if (
          this.mData.dataForm.file_ids &&
          this.mData.dataForm.file_ids.length > 0
        ) {
          let listFile = await FileApi.list(
            {
              limit: this.mData.dataForm.file_ids.length,
              filters: 'id:in:' + this.mData.dataForm.file_ids.join(','),
            },
            true
          )
          let data = []
          if (listFile && listFile.result) {
            data = listFile.result
            data.map((item) => {
              item.url = ExtensionService.urlImg + item.id
            })
          }
          this.mData.fileUploadOption.FileHoSo.fileList = data
        } else {
          this.mData.fileUploadOption.FileHoSo.fileList = []
        }

        if (this.mData.dataForm.administrative_info.identify_before_img_id) {
          let data = {}
          let file = await FileApi.findById(
            this.mData.dataForm.administrative_info.identify_before_img_id
          )
          data = file.result
          this.mData.fileUploadOption.MatTruocCMND.fileList.push(data)
        } else {
          this.mData.fileUploadOption.MatTruocCMND.fileList = []
        }

        if (this.mData.dataForm.administrative_info.identify_after_img_id) {
          let data = {}
          let file = await FileApi.findById(
            this.mData.dataForm.administrative_info.identify_after_img_id
          )
          data = file.result
          this.mData.fileUploadOption.MatSauCMND.fileList.push(data)
        } else {
          this.mData.fileUploadOption.MatSauCMND.fileList = []
        }

        if (this.mData.dataForm.card_no) {
          this.mData.isHaveTheChamCong = true
        } else {
          this.mData.isHaveTheChamCong = false
        }

        if (Array.isArray(employeeShiftApiRes.result) && employeeShiftApiRes.result.length > 0) {
          // this.mData.dataForm.shift = employeeShiftApiRes.result
          this.mData.dataForm.shift = employeeShiftApiRes.result.sort(function (a,b) {
            return (
              new Date(a.created_at).getTime() -
              new Date(b.created_at).getTime()
            )
          })
          this.mData.validForm.shift = []
          this.mData.dataForm.shift.forEach((item) => {
            if (item.end_time) {
              if (new Date(item.end_time).getTime() <= new Date().getTime()) {
                item.expiredShift = true
                this.mData.haveHistoryShift = true
              }
            }
            item.key = Math.random().toString(36).substring(2)
            item.key_dataSave = true
            this.mData.validForm.shift.push(EmployeeModel.validShift)
          })
        } else {
          this.mData.dataForm.shift = []
          this.mData.validForm.shift = []
        }

        if (!this.mData.dataForm.shift.some((item) => !item.expiredShift)) {
          const emptyShift = MethodService.copyObject(EmployeeModel.dataShift)
          emptyShift.key = Math.random().toString(36).substring(2)
          emptyShift.is_need_checkin = false
          this.mData.dataForm.shift.push(emptyShift)
          this.mData.validForm.shift.push(EmployeeModel.validShift)
        }
        this.arrShiftIds = []
        this.mData.dataForm.shift.forEach(e => {
          this.arrShiftIds.push(e.shift_id)
          if (!e.expiredShift) {
            this.mData.dataDefault.listShiftValidTime.push(e)
          }
        })

        if (!this.mData.dataForm.file_ids) {
          this.mData.dataForm.file_ids = []
        }

        //Chữ ký nhân viên
        if (employeeSignatureApiRes.result && employeeSignatureApiRes.result.length > 0) {
          const employeeSignature = employeeSignatureApiRes.result[0]
          if (!Array.isArray(employeeSignature.image_ids)) {
            employeeSignature.image_ids = []
          }
          this.mData.fileUploadOption.FileChuKy.listImageSign = []
          this.mData.dataFormEmployeeSignature = employeeSignature
          this.mData.dataForm.image_ids = employeeSignature.image_ids
          employeeSignature.image_ids.forEach(e => {
            this.mData.fileUploadOption.FileChuKy.listImageSign.push({
              showButtonDelete: false,
              id: e,
              url: ExtensionService.urlImg + e
            })
          })
          this.activeName7 = employeeSignature.image_ids.length > 0 ? 'box-card-sign' : 'box-card-sign1'
        } else {
          this.mData.dataFormEmployeeSignature = []
          this.mData.dataForm.image_ids = []
        }

        this.arrMajorIds = []
        this.arrQualificationIds = []
        this.mData.validForm.qualification = []
        if (
          this.mData.dataForm.qualification &&
          this.mData.dataForm.qualification.length > 0
        ) {
          this.mData.dataForm.qualification.forEach((item) => {
            item.key = Math.random().toString(36).substring(2)
            this.mData.validForm.qualification.push(EmployeeModel.validQualification)
            if (item.major_id) this.arrMajorIds.push(item.major_id)
            if (item.qualification_id) this.arrQualificationIds.push(item.qualification_id)
          })
          this.activeName2 = 'box-card-qualification'
        } else {
          this.activeName2 = 'box-card-qualification1'
          this.mData.dataForm.qualification = Array()
        }
        this.arrRelationshipIds = []
        this.mData.validForm.other_contact_info = []
        if (
          this.mData.dataForm.other_contact_info &&
          this.mData.dataForm.other_contact_info.length > 0
        ) {
          this.mData.dataForm.other_contact_info.forEach((item) => {
            item.key = Math.random().toString(36).substring(2)
            this.mData.validForm.other_contact_info.push(
              EmployeeModel.validOtherContactInfo
            )
            if (item.relationship_id) this.arrRelationshipIds.push(item.relationship_id)
          })
          this.activeName4 = 'box-card-other-contact-information'
        } else {
          this.activeName4 = 'box-card-other-contact-information1'
          this.mData.dataForm.other_contact_info = Array()
        }
        this.arrContractTypeIds = []
        this.arrBranchIds = []
        this.arrDepartmentIds = []
        this.arrPositionIds = []
        this.mData.validForm.job_info = [];
        (this.mData.dataForm.job_info || []).forEach((item) => {
          if (item.official_labor_contract_signed_date === undefined) {
            this.$set(item, 'official_labor_contract_signed_date', null)
          }
          item.key = Math.random().toString(36).substring(2)
          this.mData.validForm.job_info.push(EmployeeModel.validJobInfo)
          if (item.branch_id) this.arrBranchIds.push(item.branch_id)
          if (item.contract_type_id) this.arrContractTypeIds.push(item.contract_type_id)
          if (item.department_id) this.arrDepartmentIds.push(item.department_id)
          if (item.position_id) this.arrPositionIds.push(item.position_id)
        })

        this.mData.validForm.certificate = []
        if (
          this.mData.dataForm.certificate &&
          this.mData.dataForm.certificate.length > 0
        ) {
          this.mData.dataForm.certificate.forEach((item) => {
            item.key = Math.random().toString(36).substring(2)
            this.mData.validForm.certificate.push(
              EmployeeModel.validCertificate
            )
          })
          this.activeName3 = 'box-card-certificate'
        } else {
          this.activeName3 = 'box-card-certificate1'
          this.mData.dataForm.certificate = Array()
        }

        this.mData.validForm.dependent_person_info = []
        if (
          this.mData.dataForm.dependent_person_info &&
          this.mData.dataForm.dependent_person_info.length > 0
        ) {
          this.mData.dataForm.dependent_person_info.forEach((item) => {
            item.key = Math.random().toString(36).substring(2)
            this.mData.validForm.dependent_person_info.push(
              EmployeeModel.validDependentPersonInfo
              )
            if (item.relationship_id) this.arrRelationshipIds.push(item.relationship_id)
          })
          this.activeName6 = 'box-card-dependent-person'
        } else {
          this.activeName6 = 'box-card-dependent-person1'
          this.mData.dataForm.dependent_person_info = []
        }

        if (!this.mData.dataForm.salary) {
          this.mData.dataForm.salary = MethodService.copyObject(EmployeeModel.dataForm).salary
        }
        this.mData.validForm.salary.subsidies_salary = []

        this.arrCoefficientSalaryIds = []
        this.arrRankSalaryIds = []
        if (
          this.mData.dataForm.salary &&
          (this.mData.dataForm.salary.payment_method ||
          this.mData.dataForm.salary.bank_name ||
          this.mData.dataForm.salary.bank_account ||
          this.mData.dataForm.salary.bank_branch ||
          this.mData.dataForm.salary.coefficient_salary_id ||
          this.mData.dataForm.salary.rank_salary_id ||
          this.mData.dataForm.salary.gross_salary ||
          this.mData.dataForm.salary.insurance_salary)
        ) {
          this.activeName5 = 'box-card-salary'
          if (this.mData.dataForm.salary.gross_salary)  this.mData.dataForm.salary.gross_salary = this.mData.dataForm.salary.gross_salary.toString()
          if (this.mData.dataForm.salary.insurance_salary)  this.mData.dataForm.salary.insurance_salary = this.mData.dataForm.salary.insurance_salary.toString()
          if (this.mData.dataForm.salary.coefficient_salary_id) this.arrCoefficientSalaryIds.push(this.mData.dataForm.salary.coefficient_salary_id)
          if (this.mData.dataForm.salary.rank_salary_id) this.arrRankSalaryIds.push(this.mData.dataForm.salary.rank_salary_id)
        } else {
          this.activeName5 = 'box-card-salary1'
        }
        this.arrSubsidiesSalaryTypeIds = []
        if (
          this.mData.dataForm.salary &&
          this.mData.dataForm.salary.subsidies_salary &&
          this.mData.dataForm.salary.subsidies_salary.length > 0
          ) {
          this.mData.dataForm.salary.subsidies_salary.forEach((item) => {
            if (item.value) item.value = item.value.toString()
            item.key = Math.random().toString(36).substring(2)
            this.mData.validForm.salary.subsidies_salary.push(EmployeeModel.validSubsidiesSalary)
            if (item.subsidies_salary_type_id) this.arrSubsidiesSalaryTypeIds.push(item.subsidies_salary_type_id)
            if (item.subsidies_salary_type_id || item.value) {
              this.activeName5 = 'box-card-salary'
            }
          })
        } else {
          this.addRow()
        }
        if (!this.mData.dataForm.social_networks) {
          this.mData.dataForm.social_networks = []
        } else {
          this.checkAndRemoveTypeSocialNetWork()
        }
        this.checkHaveLaborContract()
        this.clearAllValidateStatus()
        this.$forceUpdate()
        setTimeout(() => {
          this.loading = false
          this.fn_innitDataDefault()
        }, 1500)
      } else {
        window.toastr.error('Nhân viên không tồn tại!')
        this.loading = false
        this.$router.push({
          name: 'Admin-EmployeeManager-list',
        })
      }
      } catch (error) {
        console.error('Load employee detail failed', error)
        window.toastr.error(error && (error.detail || error.message) ? (error.detail || error.message) : 'Không tải được thông tin nhân viên')
        this.loading = false
      }
    },
    //upload File
    fn_uploadRemoveFile() {
      this.mData.dataDefault.anh = null
      this.mData.dataForm.administrative_info.avatar_id = null
      this.mData.fileUploadOption.Anh.fileList = []
      this.mData.validForm.administrative_info.avatar_id = [
        ValidService.requiredChange,
      ]
      this.haveAvatar = false
    },
    async fn_uploadChangeFile(file, fileList) {
      if(!this.checkTypeImagae(file.name)){
        window.toastr.warning('Ảnh phải có định dạng là png, jpg hoặc jpeg')
        this.mData.fileUploadOption.Anh.fileList = []
        return
      }
      if(!this.checkFileSize(file.size)){
        window.toastr.warning('Ảnh tải lên có dung lương không quá 10MB')
        this.mData.fileUploadOption.Anh.fileList = []
        return
      }
      ExtensionService.upload(file, 'fileNhanVien')
        .then((res) => {
          this.loadAvatarImage = true
          this.mData.dataForm.administrative_info.avatar_id = res.result
          this.mData.dataForm.avatarUrl = ExtensionService.urlImg + res.result
          this.haveAvatar = true
          this.mData.fileUploadOption.Anh.fileList = fileList
          this.$refs['myProfileForm'].clearValidate(
            'administrative_info.avatar_id'
          )
          // this.$refs['myProfileForm'].validateField('administrative_info.avatar_id')
          if (this.mData.dataForm.administrative_info.avatar_id) {
            this.mData.validForm.administrative_info.avatar_id = []
          }
          // this.$refs['myProfileForm'].validateField('administrative_info.avatar_id')
          this.loadAvatarImage = false
        })
        .catch((error) => {
          this.loadAvatarImage = false
          this.mData.validForm.administrative_info.avatar_id = [
            ValidService.requiredChange,
          ]
          this.$refs['myProfileForm'].clearValidate(
            'administrative_info.avatar_id'
          )
          // this.$refs['myProfileForm'].validateField('administrative_info.avatar_id')
          window.toastr.error('Có lỗi xảy ra, vui lòng thử lại!')
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1)
            }
          })
        })
    },
    async fn_uploadChangePersonalImage(file, fileList) {
      if(!this.checkTypeImagae(file.name)){
        window.toastr.warning('Ảnh phải có định dạng là png, jpg hoặc jpeg')
        this.mData.fileUploadOption.AnhCaNhan.fileList = []
        return
      }
      if(!this.checkFileSize(file.size)){
        window.toastr.warning('Ảnh tải lên có dung lương không quá 10MB')
        this.mData.fileUploadOption.AnhCaNhan.fileList = []
        return
      }
      ExtensionService.upload(file, 'anhCaNhanNhanVien')
        .then((res) => {
          this.loadPersonalImage = true
          this.mData.dataForm.image_id = res.result
          this.mData.dataForm.PersonalImageUrl = ExtensionService.urlImg + res.result
          this.haveAvatar = true
          this.mData.fileUploadOption.AnhCaNhan.fileList = fileList
          this.loadPersonalImage = false
        })
        .catch((error) => {
          this.loadPersonalImage = false
          window.toastr.error('Có lỗi xảy ra, vui lòng thử lại!')
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1)
            }
          })
        })
    },
    checkTypeImagae(fileName){
      let lastIndexOfDot = fileName.lastIndexOf('.')
      let fileType = fileName.substr(lastIndexOfDot + 1, fileName.length)
      let typeImage = ['png', 'jpg', 'jpeg']
      if (!typeImage.includes(fileType.toLowerCase())) {
        return false
      } else {
        return true
      }
    },
    checkFileSize(fileSize) {
      let fileSizeMb = fileSize / 1024 / 1024
      if (fileSizeMb > 10) return false
      return true
    },
    fn_uploadExceedFile(files, fileList) {
      window.toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.Anh.limit} file`
      )
    },
    handlePictureCardPreview(file) {
      this.mData.fileUploadOption.Anh.dialogImageUrl = file.url
      this.mData.fileUploadOption.Anh.dialogVisible = true
    },
    async fn_uploadFile(file, fileList) {
      ExtensionService.upload(file, 'HoSo')
        .then((res) => {
          this.mData.dataForm.file_ids.push(res.result)
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result
            }
          })
          this.mData.fileUploadOption.FileHoSo.fileList = fileList
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1)
            }
          })
        })
    },
    fn_downloadFile(file) {
      window.open(ExtensionService.urlDowloadFile + file.id)
    },
    fn_removeFile(file, fileList) {
      let data = fileList.map((el) => el.id)
      this.mData.dataForm.file_ids = data
    },
    fn_previewFile(file) {
      this.mData.fileUploadOption.dialogImageUrl = this.imgUrl + file.id
      this.mData.fileUploadOption.dialogVisible = true
    },
    fn_uploadMatTruocCMND(file, fileList) {
      // if(this.mData.dataForm.administrative_info.name.first_name){
      //   let textAfterRemoveSign = MethodService.changeAlias(this.mData.dataForm.administrative_info.name.first_name)
      //   const arrText = textAfterRemoext.length i++) {veSign.split(' ')
      //   for (var i = 0 i < arrT
      //     arrText[i] = arrText[i].charAt(0).toUpperCase() + arrText[i].slice(1)
      //   }
      //     const str2 = arrText.join('')
      //     file.name = str2+'_MatTruocCMND'
      // }else{
      //   file.name = 'MatTruocCMND'
      // }
      ExtensionService.upload(file, 'MatTruocCMND')
        .then((res) => {
          this.mData.dataForm.administrative_info.identify_before_img_id =
            res.result
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result
            }
          })
          this.mData.fileUploadOption.MatTruocCMND.fileList = fileList
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1)
            }
          })
        })
    },
    fn_removeMatTruocCMND(file, fileList) {
      this.mData.dataForm.administrative_info.identify_before_img_id = null
      this.mData.fileUploadOption.MatTruocCMND.fileList = []
    },
    fn_uploadMatSauCMND(file, fileList) {
      // if(this.mData.dataForm.administrative_info.name.first_name){
      //   let textAfterRemoveSign = MethodService.changeAlias(this.mData.dataForm.administrative_info.name.first_name)
      //   const arrText = textAfterRemoveSign.split(' ')
      //   for (var i = 0 i < arrText.length i++) {
      //     arrText[i] = arrText[i].charAt(0).toUpperCase() + arrText[i].slice(1)
      //   }
      //     const str2 = arrText.join('')
      //     file.name = str2+'_MatSauCMND'
      // }else{
      //   file.name = 'MatSauCMND'
      // }
      ExtensionService.upload(file, 'MatSauCMND')
        .then((res) => {
          this.mData.dataForm.administrative_info.identify_after_img_id =
            res.result
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result
            }
          })
          this.mData.fileUploadOption.MatSauCMND.fileList = fileList
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1)
            }
          })
        })
    },
    fn_removeMatSauCMND(file, fileList) {
      this.mData.dataForm.administrative_info.identify_after_img_id = null
      this.mData.fileUploadOption.MatSauCMND.fileList = []
    },
    checkTypeImageBeforeUpload(file) {
      if (file.raw && file.raw.type == 'image/png') {
        return true
      } else {
        toastr.warning('Chỉ được tải lên file ảnh có định dạng PNG')
        return false
      }
    },
    //Chữ ký nhân viên
    async fn_uploadSign(file, fileList) {
      if (!this.checkTypeImageBeforeUpload(file)) return
      const res = await ExtensionService.upload(file, 'ChuKyNhanVien')
      if (res && res.result) {
        let resultCheck = await MethodService.checkWidthHeightImage(res.result, 220, 220)
        if (!resultCheck.status) {
          toastr.warning(resultCheck.message ? resultCheck.message : 'Kích thước ảnh không hợp lệ')
          return
        }
        this.mData.dataForm.image_ids.push(res.result)
        this.mData.fileUploadOption.FileChuKy.listImageSign.push({
          showButtonDelete: false,
          id: res.result,
          url: ExtensionService.urlImg + res.result
        })
      }
    },
    fn_removeSignImage(imageId){
      this.mData.dataForm.image_ids = this.mData.dataForm.image_ids.filter(el => el != imageId)
      this.mData.fileUploadOption.FileChuKy.listImageSign = this.mData.fileUploadOption.FileChuKy.listImageSign.filter(el => el.id != imageId)
    },
    clearValidateStatus(colection, fieldList, index){
      fieldList.forEach(field => {
        this.$refs['myProfileForm'].clearValidate(
          `${colection}[${index}].${field}`
        )
      })
    },
    handleActiveShiftChange(val) {
      this.forceUpdateUI()
      if (!val) return

      const activeShiftIndex = this.mData.dataForm.shift.findIndex((s) => !s.expiredShift)
      if (activeShiftIndex >= 0) {
        this.$refs['myProfileForm'].clearValidate(`shift[${activeShiftIndex}].shift_id`)
      }
    },
    handleEmptyShiftChange(val) {
      if (!val) return

      this.mData.dataForm.shift.push({ shift_id: val, is_need_checkin: true })
      this.forceUpdateUI()
      this.$nextTick(() => {
        this.$refs['myProfileForm'].clearValidate('shift[0].shift_id')
      })
    },
    handleShiftCheckinChange(index) {
      this.forceUpdateUI()
      this.$nextTick(() => {
        if (this.$refs['myProfileForm']) {
          this.$refs['myProfileForm'].clearValidate(`shift[${index}].shift_id`)
        }
      })
    },
    handleActiveShiftCheckinChange() {
      this.forceUpdateUI()
      const activeShiftIndex = this.mData.dataForm.shift.findIndex((s) => !s.expiredShift)
      this.$nextTick(() => {
        if (activeShiftIndex >= 0 && this.$refs['myProfileForm']) {
          this.$refs['myProfileForm'].clearValidate(`shift[${activeShiftIndex}].shift_id`)
        }
      })
    },
    //Thông tin chấm công
    newInformationTimekeeping() {
      this.loadShift = false
      this.loadTimeStart = false
      let dataAdd = MethodService.copyObject(EmployeeModel.dataShift)
      dataAdd.key = Math.random().toString(36).substring(2)
      this.mData.dataForm.shift.unshift(dataAdd)
      this.mData.validForm.shift.unshift(EmployeeModel.validShift)
      this.forceUpdateUI()
      setTimeout(() => {
        this.loadShift = true
        this.loadTimeStart = true
      }, 0.1)
    },
    removeInformationTimekeeping(key,index) {
      let checkShift = this.mData.dataForm.shift.filter((e) => {
        return (
          !e.end_time || new Date(e.end_time).getTime() >= new Date().getTime()
        )
      })
      if (checkShift && checkShift.length == 1) {
        window.toastr.warning('Nhân viên phải có ít nhất 1 ca làm việc!')
        this.loadShift = true
        this.loadTimeStart = true
        return
      }
      let shift = this.mData.dataForm.shift.find((el) => el.key == key)
      if (
        ( new Date(shift.start_time).getTime() < new Date().getTime() ) &&
        ( shift.end_time && new Date(shift.end_time).getTime() > new Date().getTime() )
      ) {
        window.toastr.warning('Ca làm việc đang có hiệu lực, không thể xóa')
        return
      }
      let data = this.mData.dataForm.shift.filter((el) => el.key !== key)
      let dataRemove = this.mData.dataForm.shift.find((el) => el.key === key)
      this.mData.shiftRemove.push(dataRemove)
      this.mData.dataForm.shift = data
      this.forceUpdateUI()
      this.mData.dataDefault.listShiftValidTime = MethodService.copyObject(this.mData.dataForm.shift)
      this.mData.validForm.shift = this.mData.validForm.shift.splice(index, 1)
      setTimeout(() => {
        this.clearValidateStatus('shift', ['shift_id','start_time'],index)
        // setTimeout(() => {
        //   this.validateFieldMethod(`shift[${index}].shift_id`)
        //   this.validateFieldMethod(`shift[${index}].start_time`)
        // }, 1000)
      }, 100)
    },

    selectTimeDiMuon(time) {
      return (this.mData.timeDiMuon = time)
    },
    selectTimeVeSom(time) {
      return (this.mData.timeVeSom = time)
    },
    fn_checkTotalTime(index, type) {
      if (this.mData.timeDiMuon + this.mData.timeVeSom > 60) {
        window.toastr.error(
          'Tổng thời gian đi sớm và về muộn trong ngày không quá 60 phút!'
        )
        this.mData.dataForm.shift[index].number_of_late_minute = 0
        this.mData.dataForm.shift[index].number_of_leave_early_minute = 0
        this.mData.timeDiMuon = 0
        this.mData.timeVeSom = 0
      }
    },

    //Thông tin công việc
    newInformationJob() {
      this.loadContracType = false
      this.loadTimeStartCT = false
      let dataAdd = MethodService.copyObject(EmployeeModel.dataJobInfo)
      dataAdd.key = Math.random().toString(36).substring(2)
      if (!this.mData.dataForm.job_info) this.mData.dataForm.job_info = []
      this.mData.dataForm.job_info.unshift(dataAdd)
      if (!this.mData.validForm.job_info) this.mData.validForm.job_info = []
      this.mData.validForm.job_info.unshift(MethodService.copyObject(EmployeeModel.validJobInfo))
      this.forceUpdateUI()
      setTimeout(() => {
        this.loadContracType = true
        this.loadTimeStartCT = true
      }, 0.1)
    },
    removeInformationJob(key,index) {
      if (
        this.mData.dataForm.job_info &&
        this.mData.dataForm.job_info.length == 1
      ) {
        window.toastr.warning(
          'Nhân viên phải có ít nhất 1 thông tin công việc!'
        )
        return
      }
      let data = this.mData.dataForm.job_info.filter((el) => el.key !== key)
      this.mData.dataForm.job_info = data
      this.mData.validForm.job_info = this.mData.validForm.job_info.splice(index, 1)
      this.forceUpdateUI()
      setTimeout(() => {
        this.clearValidateStatus('job_info', ['kind_of_contract','contract_type_id','start_date'],index)
      }, 100)
    },

    //Trình độ chuyên môn
    newQualification() {
      let dataAdd = MethodService.copyObject(EmployeeModel.dataQualification)
      dataAdd.key = Math.random().toString(36).substring(2)
      if (!this.mData.dataForm.qualification) this.mData.dataForm.qualification = []
      this.mData.dataForm.qualification.push(dataAdd)
      this.mData.validForm.qualification.push(
        EmployeeModel.validQualification
      )
      this.forceUpdateUI()
    },
    removeQualification(key,index) {
      let data = this.mData.dataForm.qualification.filter(
        (el) => el.key !== key
      )
      this.mData.dataForm.qualification = data
      this.mData.validForm.qualification = this.mData.validForm.qualification.splice(index, 1)
      this.forceUpdateUI()
      setTimeout(() => {
        this.clearValidateStatus('qualification', ['qualification_id','major_id','issued_by','issued_date'],index)
      }, 100)
    },

    //Chứng chỉ
    newCertificate() {
      let dataAdd = MethodService.copyObject(EmployeeModel.dataCertificate)
      dataAdd.key = Math.random().toString(36).substring(2)
      if (!this.mData.dataForm.certificate) this.mData.dataForm.certificate = []
      this.mData.dataForm.certificate.push(dataAdd)
      this.mData.validForm.certificate.push(EmployeeModel.validCertificate)
      this.forceUpdateUI()
    },
    removeCertificate(key,index) {
      let data = this.mData.dataForm.certificate.filter((el) => el.key !== key)
      this.mData.dataForm.certificate = data
      this.mData.validForm.certificate = this.mData.validForm.certificate.splice(index, 1)
      this.forceUpdateUI()
      setTimeout(() => {
        this.clearValidateStatus('certificate', ['name','issued_by','issued_date'],index)
      }, 100)
    },

    //Thông tin liên hệ khác
    newOtherContactInformation() {
      let dataAdd = MethodService.copyObject(
        EmployeeModel.dataOtherContactInfo
      )
      dataAdd.key = Math.random().toString(36).substring(2)
      if (!this.mData.dataForm.other_contact_info) this.mData.dataForm.other_contact_info = []
      this.mData.dataForm.other_contact_info.push(dataAdd)
      this.mData.validForm.other_contact_info.push(
        EmployeeModel.validOtherContactInfo
      )
      this.forceUpdateUI()
    },
    removeOtherContactInformation(key,index) {
      let data = this.mData.dataForm.other_contact_info.filter(
        (el) => el.key !== key
      )
      this.mData.dataForm.other_contact_info = data
      this.mData.validForm.other_contact_info = this.mData.validForm.other_contact_info.splice(index, 1)
      this.forceUpdateUI()
      setTimeout(() => {
        this.clearValidateStatus('other_contact_info', ['full_name','relationship_id','phone_number'],index)
      }, 100)
    },

    //Thông tin người phụ thuộc
    newDependentPerson() {
      let dataAdd = MethodService.copyObject(
        EmployeeModel.dataDependentPersonInfo
      )
      dataAdd.key = Math.random().toString(36).substring(2)
      if (!this.mData.dataForm.dependent_person_info) this.mData.dataForm.dependent_person_info = []
      this.mData.dataForm.dependent_person_info.push(dataAdd)
      this.mData.validForm.dependent_person_info.push(
        EmployeeModel.validDependentPersonInfo
      )
      this.forceUpdateUI()
    },
    removeDependentPerson(key,index) {
      let data = this.mData.dataForm.dependent_person_info.filter(
        (el) => el.key !== key
      )
      this.mData.dataForm.dependent_person_info = data
      this.mData.validForm.dependent_person_info = this.mData.validForm.dependent_person_info.splice(index, 1)
      this.forceUpdateUI()
      setTimeout(() => {
        this.clearValidateStatus('dependent_person_info', ['full_name','relationship_id','registered_date'],index)
      }, 100)
    },

    //Trợ cấp
    addRow() {
      let dataAdd = MethodService.copyObject(EmployeeModel.dataSubsidiesSalary)
      dataAdd.key = Math.random().toString(36).substring(2)
      this.mData.dataForm.salary.subsidies_salary.push(dataAdd)
      this.mData.validForm.salary.subsidies_salary.push(
        EmployeeModel.validSubsidiesSalary
      )
      this.forceUpdateUI()
    },
    removeRow(key,index) {
      if (
        this.mData.dataForm.salary.subsidies_salary &&
        this.mData.dataForm.salary.subsidies_salary.length == 1
      ) {
        window.toastr.warning('Phải có ít nhất 1 trợ cấp')
        return
      }
      let data = this.mData.dataForm.salary.subsidies_salary.filter(
        (el) => el.key !== key
      )
      this.mData.dataForm.salary.subsidies_salary = data
      this.forceUpdateUI()
      setTimeout(() => {
        this.clearValidateStatus('salary.subsidies_salary', ['subsidies_salary_type_id','value'],index)
      }, 100)
    },

    //
    forceUpdateUI() {
      this.$forceUpdate()
    },
    fn_resetForm() {
      this.mData.fileUploadOption.Anh = {
        limit: 1,
        accept: '.jpg, .png, .jpeg',
        dialogImageUrl: '',
        dialogVisible: false,
        fileList: [],
      }
      this.$refs['myProfileForm'].resetFields()
      this.mData.isHaveTheChamCong = false
      this.mData.dataForm.card_no = ''
      this.mData.dataForm.shift = []
      this.mData.dataForm.job_info = []
      this.mData.dataForm.qualification = []
      this.mData.dataForm.certificate = []
      this.mData.dataForm.other_contact_info = []
      this.mData.dataForm.dependent_person_info = []
      this.mData.dataForm.salary.subsidies_salary = []
      this.mData.dataDefault.listShiftValidTime = []
    },
    setDisableTime(index) {
      if (!this.mData.dataForm.shift[index].shift_id) {
        this.pickerOptions = {
          disabledDate(time) {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Đặt về 00:00:00 để chỉ so sánh ngày
            return time.getTime() < today.getTime(); // Chỉ disable ngày trước hôm nay
          },
        };
      } else {
        
        let shift = this.mData.dataDefault.listCaLamViec.find((item) => {
          return item.id == this.mData.dataForm.shift[index].shift_id
        })
        let start = shift.applied_start_time
        let end = shift.applied_end_time
        let now = new Date()
        let timeStartDisable = ''
        if (new Date(start).getTime() > new Date(now).getTime()) {
          timeStartDisable = start
        } else if (new Date(start).getTime() < new Date(now).getTime()) {
          timeStartDisable = now
        }
        this.pickerOptions = {
          disabledDate(time) {
            const start = new Date(timeStartDisable);
            const endDate = new Date(end);

            // Đặt thời gian về 00:00:00 để so sánh chính xác theo ngày
            start.setHours(0, 0, 0, 0);
            endDate.setHours(0, 0, 0, 0);
            const current = new Date(time);
            current.setHours(0, 0, 0, 0);

            return current < start || current > endDate;
          },
        };
      }
    },
    changeShift(index, shiftId) {
      let checkDuplicateShift = undefined
      if (this.mData.viewMode != 'create') {
        checkDuplicateShift = this.mData.dataDefault.listShiftValidTime.filter((e,i) => {
          return e.shift_id && e.shift_id == shiftId && !e.expiredShift
        })
      } else if (this.mData.viewMode == 'create') {
        checkDuplicateShift = this.mData.dataDefault.listShiftValidTime.filter((e,i) => {
          return e.shift_id && e.shift_id == shiftId
        })
      }
      if (checkDuplicateShift && checkDuplicateShift.length > 0) {
        this.mData.dataForm.shift[index].shift_id = undefined
        this.mData.dataDefault.listShiftValidTime = MethodService.copyObject(this.mData.dataForm.shift)
        window.toastr.error('Không được chọn trùng lặp ca!')
        this.$nextTick(() => this.$refs['`shift[${index}].shift_id`'].focus())
        this.loadShift = true
        return
      }
      this.loadShift = false
      this.mData.dataDefault.listShiftValidTime = MethodService.copyObject(this.mData.dataForm.shift)
      this.mData.dataForm.shift[index].start_time = undefined
      this.loadTimeStart = false
      setTimeout(() => {
        this.loadTimeStart = true
      }, 0.000001)

      let shiftInfor = this.mData.dataDefault.listCaLamViec.find((e) => {
        return e.id == shiftId
      })
      if (shiftInfor && shiftInfor.applied_end_time) {
        let time = new Date(shiftInfor.applied_end_time)
        let time39h59 = new Date(
          time.getFullYear(),
          time.getMonth(),
          time.getDate(),
          23,
          59,
          59
        )
        this.mData.dataForm.shift[index].end_time = time39h59
      }
      setTimeout(() => {
        this.loadShift = true
      }, 0.00000000001)
    },

    changeTimeStart(index) {
      this.loadTimeStart = false
      if (this.mData.dataForm.shift[index].end_time) {
        if (
          new Date(this.mData.dataForm.shift[index].start_time).getTime() >
          new Date(this.mData.dataForm.shift[index].end_time).getTime()
        ) {
          window.toastr.warning(
            'Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu'
          )
          this.$refs[`shift[${index}].end_time`].focus()
        }
      }
      setTimeout(() => {
        this.loadTimeStart = true
      }, 0.01)
    },

    changeTimeEnd(index) {
      if (this.mData.dataForm.shift[index].end_time) {
        if (
          new Date(this.mData.dataForm.shift[index].start_time).getTime() >
          new Date(this.mData.dataForm.shift[index].end_time).getTime()
        ) {
          window.toastr.warning(
            'Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu'
          )
          this.$refs[`shift[${index}].end_time`].focus()
        }
        let time = new Date(this.mData.dataForm.shift[index].end_time)
        let time39h59 = new Date(
          time.getFullYear(),
          time.getMonth(),
          time.getDate(),
          23,
          59,
          59
        )
        this.mData.dataForm.shift[index].end_time = time39h59
      }
    },

    changeTimeStartInfomationJod(index) {
      this.loadTimeStartCT = false
      this.fn_updateSeniority()
      if (this.mData.dataForm.job_info[index].end_date) {
        if (
          new Date(this.mData.dataForm.job_info[index].start_date).getTime() >
          new Date(this.mData.dataForm.job_info[index].end_date).getTime()
        ) {
          window.toastr.warning(
            'Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu'
          )
          this.$refs[`job_info[${index}].end_date`].focus()
        }
      }
      this.checkHaveLaborContract()
      setTimeout(() => {
        this.loadTimeStartCT = true
      }, 0.01)
    },

    changeTimeEndInfomationJod(index) {
      if (this.mData.dataForm.job_info[index].end_date) {
        if (
          new Date(this.mData.dataForm.job_info[index].start_date).getTime() >
          new Date(this.mData.dataForm.job_info[index].end_date).getTime()
        ) {
          window.toastr.warning(
            'Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu'
          )
          this.$refs[`job_info[${index}].end_date`].focus()
        }
        let time = new Date(this.mData.dataForm.job_info[index].end_date)
        let time39h59 = new Date(
          time.getFullYear(),
          time.getMonth(),
          time.getDate(),
          23,
          59,
          59
        )
        this.mData.dataForm.job_info[index].end_date = time39h59
      }
      this.checkHaveLaborContract()
    },

    changeTimeStartDependentPerson(index) {
      if (this.mData.dataForm.dependent_person_info[index].expired_date) {
        if (
          new Date(
            this.mData.dataForm.dependent_person_info[index].registered_date
          ).getTime() >
          new Date(
            this.mData.dataForm.dependent_person_info[index].expired_date
          ).getTime()
        ) {
          window.toastr.warning(
            'Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu'
          )
          this.$refs[`dependent_person_info[${index}].expired_date`].focus()
        }
      }
    },

    changeTimeEndDependentPerson(index) {
      if (this.mData.dataForm.dependent_person_info[index].expired_date) {
        if (
          new Date(
            this.mData.dataForm.dependent_person_info[index].registered_date
          ).getTime() >
          new Date(
            this.mData.dataForm.dependent_person_info[index].expired_date
          ).getTime()
        ) {
          window.toastr.warning(
            'Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu'
          )
          this.$refs[`dependent_person_info[${index}].expired_date`].focus()
        }
        let time = new Date(
          this.mData.dataForm.dependent_person_info[index].expired_date
        )
        let time39h59 = new Date(
          time.getFullYear(),
          time.getMonth(),
          time.getDate(),
          23,
          59,
          59
        )
        this.mData.dataForm.dependent_person_info[index].expired_date =
          time39h59
      }
    },
    emitGlobalDataChange() {
      let eventName = 'changeEmployeeInformation'
      EventBus.$emit(eventName)
    },
    checkAndRemoveTypeSocialNetWork(){
      this.mData.listTypeSocialNetwork = []
      this.mData.dataDefault.listSocialMediaNetwork = DataService.listSocialMediaNetwork
      this.mData.dataForm.social_networks.forEach(e => {
        this.mData.listTypeSocialNetwork.push(e.type)
      })
      if (this.mData.dataForm.social_networks.length == 5) {
        this.checkEnoughSocialNetwork = true
      } else {
        this.checkEnoughSocialNetwork = false
      }
      if (this.mData.listTypeSocialNetwork.length > 0) {
        this.mData.listTypeSocialNetwork.forEach(x => {
          let a = this.mData.dataDefault.listSocialMediaNetwork.filter(y => y.value != x)
          this.mData.dataDefault.listSocialMediaNetwork = a
        })
      }
    },
    addNewSocialNetwork(){
      this.typeChangeSocialNetwork = 'create'
      this.checkAndRemoveTypeSocialNetWork()
      setTimeout(() => {
        this.visibleDialogSocialNetwork = true
        // if (this.mData.dataForm.social_networks.length == 5) {
        //   this.checkEnoughSocialNetwork = true
        // }
      }, 200)
    },
    beforeCloseDialogSocialNetwork(){
      this.$refs['formSocialNetwork'].fields.find((f) => f.prop == 'type').resetField()
      this.$refs['formSocialNetwork'].fields.find((f) => f.prop == 'url').resetField()
      this.mData.dataDefault.listSocialMediaNetwork = DataService.listSocialMediaNetwork
      this.mData.dataFormSocialNetWork.url = undefined
      this.mData.dataFormSocialNetWork.type = undefined
      this.visibleDialogSocialNetwork = false
    },
    submitFormSocialNetwork(type){
      this.$refs['formSocialNetwork'].validate(async (valid) => {
        if (valid) {
          let data = {
            url: this.mData.dataFormSocialNetWork.url,
            type: this.mData.dataFormSocialNetWork.type,
            key: Math.random().toString(36).substring(2)
          }
          let nameSocialNetwork = this.mData.dataDefault.listSocialMediaNetwork.find(e => e.type == this.mData.dataFormSocialNetWork.type)
          if (nameSocialNetwork && nameSocialNetwork.label) {
            data.name = nameSocialNetwork.label
          }
          if (type == 'create') {
            this.mData.dataForm.social_networks.push(data)
            if (this.mData.dataForm.social_networks.length == 5)
              this.checkEnoughSocialNetwork = true
          } else {
            this.mData.dataForm.social_networks.forEach(e => {
              if (e.type == data.type) {
                e.url = data.url
              }
            })
          }
          setTimeout(() => {
            this.beforeCloseDialogSocialNetwork()
          }, 200)
        } else {
          MethodService.stopLadda()
          return false
        }
      })
    },
    goToLinkUrl(url){
      window.open(url, '_blank').focus()
    },
    showDetailImage(url){
      this.urlImage = url
      setTimeout(() => {
        this.visibleDialogImage = true
      }, 100)
    },
    closeViewer() {
      this.visibleDialogImage = false
    },
    beforeCloseDialogImage(){
      this.urlImage = ''
      this.visibleDialogImage = false
    },
    updateSocialNetwork(data){
      this.typeChangeSocialNetwork = 'update'
      this.mData.dataDefault.listSocialMediaNetwork = DataService.listSocialMediaNetwork.filter(e => e.value == data.type)
      this.mData.dataFormSocialNetWork.type = data.type
      this.mData.dataFormSocialNetWork.url = data.url
      this.visibleDialogSocialNetwork = true
    },
    removeSocialNetwork(index){
      this.mData.dataForm.social_networks = this.mData.dataForm.social_networks.filter((e,i) => {
        return i != index
      })
      this.checkAndRemoveTypeSocialNetWork()
    }
  },
  watch: {
    'mData.dataForm.company_id'(newVal, oldVal) {
      if (!newVal || newVal === oldVal) return
      this.fn_getListDirectManagerOptions()
    }
  },
  created() {
    this.fn_getListOrganizationModelTree()
    if (this.$router.currentRoute.name == 'Admin-EmployeeInfo-detail') {
      this.mData.viewMode = 'employeeInfo'
    }
    if (
      this.$router.currentRoute.name ==
      'Admin-' + this.mData.moduleName + '-create'
    ) {
      this.mData.viewMode = 'create'
      this.mData.dataForm.status = 'DANG_LAM_VIEC'
      this.fn_innitDataDefault()
    }
    if (
      this.$router.currentRoute.name ==
      'Admin-' + this.mData.moduleName + '-update'
    ) {
      this.mData.viewMode = 'update'
    }
    if (
      this.$router.currentRoute.name ==
      'Admin-' + this.mData.moduleName + '-detail'
    ) {
      this.mData.viewMode = 'update'
    }
    if (this.$router.currentRoute.params.id) {
      this.mData.employeeId = this.$router.currentRoute.params.id
      this.fn_getDataById(this.$router.currentRoute.params.id)
    }
    EventBus.$off('click_HSCN')
    EventBus.$off('rowClick')
    EventBus.$off('tab_HSCN')
    EventBus.$on('click_HSCN', (data) => {
      if (data.type_button == 'create') {
        this.fn_submit('create')
      } else if (data.type_button == 'update') {
        this.fn_submit('update')
      }
    })
    EventBus.$on('rowClick_HSCN', (data) => {
      this.fn_getDataById(data.id)
    })
    EventBus.$on('tab_HSCN', () => {
      this.fn_getDataById(this.$router.currentRoute.params.id)
    })
  },
}
</script>

<style lang="scss" scoped>
::v-deep .employee-sign {
  .sign-image-name {
    font-size: 15px;
    font-weight: 500;
  }
  .el-image {
    max-width: 350px;
  }
}
::v-deep .signature-upload .el-upload-dragger {
  width: 220px !important;
  height: 220px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.signature-upload-preview {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
}
::v-deep .signature-upload-image {
  width: 100%;
  height: 100%;
}
::v-deep .signature-upload-image img {
  object-fit: contain !important;
}
.signature-upload-delete {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 9;
  padding: 6px 8px;
}
.social-div {
  display: flex;
  margin-bottom: 10px;
  .social-media {
    margin-left: 10px;
    padding-left: 10px;
    padding-right: 10px;
    .social-media__box{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      p{
        font-size: 14px;
        line-height: 19px;
        font-weight: 400;
        display: block;
        width: 350px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover{
          cursor: pointer;
        }
      }
      .social__media-icon {
        width: 32px;
        height: 32px;
        margin-right: 10px;
      }
    }
  }
}
::v-deep .seniority {
  .el-form-item__content {
    display: flex;
    align-items: center;
    height: 32px;
  }
}
::v-deep .time-attendance-photo {
  margin-bottom: 15px;
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
.btn-delete-image {
  position: absolute;
  top: 40%;
  left: 42%;
  z-index: 9;
}
.avatar__image:hover{
  cursor: pointer;
}
.isax-save-remove{
  margin-right: 5px;
}
.isax-save-remove::before{
  color: var(--red);
}
.isax-edit::before,
.isax-save-remove::before{
  font-size: 17px;
}
.isax-edit:hover,
.isax-save-remove:hover{
  cursor: pointer;
}
::v-deep .el-icon-close-tip {
  display: none !important;
}
.img__icon-plus{
  width: 39px;
  height: 39px;
  background-color: #fff;
  box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
  border-radius: 50%;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.div-puls__subsidies_salary{
  display: flex;
  position: absolute;
  justify-content: center;
  bottom: -5px;
}
p {
  margin-bottom: 0;
}
::v-deep .el-icon-plus:before{
  font-size: 30px;
  color: var(--orange);
}
.mouse__hover:hover{
  cursor: pointer;
}
.title-card-header {
  font-family: UTM AvoBold !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;
  color: var(--orange);
  text-transform: unset;
}
::v-deep .el-collapse {
  border: 1px solid #ebeef5;
  background-color: #fff;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border-radius: 4px;
  // box-shadow: 0 2px 12px 0 rgba(0 0 0 / 10%);
  box-shadow: 0 2px 12px 0 rgba(143, 140, 140, 0.2);
}
::v-deep .el-collapse-item__header {
  background-color: #fff !important;
  border-radius: 4px;
}
.justify-content {
  justify-content: center;
  align-items: center;
}
.hide {
  ::v-deep.el-upload.el-upload--text {
    display: none;
  }
}

.hide_div {
  display: none;
}
.box-card-information-administrative .aside__infomation{
  max-width: 230px;
  width: 230px;
  margin-right: 5px;
}
.fd-r{
  flex-direction: column;
}
.aside__infomation .div-avatar{
  display: flex;
  justify-content: center;
}
.aside__infomation .div-avatar .el-image{
  width: 190px;
  height: 190px;
  border-radius: 50%;
}
.upload-demo{
  margin-top: 10px !important;
  width: 94px;
  margin: 0 auto;
}
.upload-demo .el-upload .el-button{
  padding: 5px 23px;
  border-radius: 5px !important;
}
.box-card-information-administrative .main__infomation{
  width: calc(100% - 260px);
}
.btn-add-new {
  padding: 13px 60px;
  font-size: 14px;
}
::v-deep .avatar_employee .el-form-item .el-form-item__content {
  margin-left: 0 !important;
}
::v-deep label {
  margin-bottom: 0;
}
.btn-add-row {
  font-size: 2rem;
  border: none;
}
::v-deep .el-upload-list__item {
  transition: none !important;
}
::v-deep .employee-file .el-upload-dragger {
  height: 36px;
}
.p-relative {
  position: relative;
}
.job-info-group {
  padding: 0;
}
.job-info-item {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.remove-icon {
  position: absolute;
  top: 2px;
  right: 1px;
  max-width: 25px;
  height: 25px;
  border-radius: 10px;
}
.c-ponit:hover {
  cursor: pointer;
}
::v-deep .el-upload-list {
  display: flex;
  align-items: center;
  align-content: center;
}
::v-deep .el-upload-list__item:first-child {
  margin-top: 0;
}
::v-deep .el-upload-list__item {
  margin-top: 0;
}
::v-deep .col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col,
.col-auto,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm,.col-sm-auto,
.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md,.col-md-auto,
.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg,.col-lg-auto,
.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl,.col-xl-auto {
  padding-left: 10px;
  padding-right: 10px;
}

.dialog-image {
  max-height: calc(100vh - 158px);
}

.fas_icon {
  // top: -15px;
  z-index: 9;
  position: absolute;
  left: 160px;
}
.fas_icon:hover {
  cursor: pointer;
}
.demo-upload__image {
  width: 144px;
  height: 144px;
  border-radius: 7px;
  top: 2px;
  left: 2px;
  opacity: 0.5;
}
.upload-image {
  position: absolute;
  z-index: 9;
  top: 0;
}
::v-deep .el-upload--picture-card {
  background-color: transparent;
}
::v-deep .account .el-form-item__error {
  line-height: 1.39;
}
::v-deep .dialog-history .el-dialog .el-dialog__body {
  max-height: calc(100vh - 120px);
  overflow: auto;
}
::v-deep .el-collapse-item__arrow{
  font-size: 20px;
  font-weight: 900;
  color: var(--orange);
}
::v-deep .el-switch__core{
  height: 30px;
  width: 60px !important;
  border-radius: 45px;
}
::v-deep .el-switch__core:after{
  border-radius: 50%;
  height: 30px;
  width: 30px;
  top: -1px;
  left: -1px;
}
::v-deep .el-switch.is-checked .el-switch__core::after{
  margin-left: -30px;
}
::v-deep .social__media-box .el-form-item__content {
  margin-left: 0px !important;
}
.add-new-social__network {
  flex-shrink: 0;
  &:hover {
    cursor: pointer;
  }
  .add-new-social__network-text{
    color: var(--link-color);
  }
}
::v-deep .dialog__social-netwotk .el-dialog__header {
  padding: 8px 10px 8px 8px;
}
::v-deep .dialog__social-netwotk .el-dialog__title {
  text-transform: uppercase;
}
::v-deep .employee-sign {
  .el-form-item__content {
    margin-left: 0px !important;
  }
  .el-upload-list--text {
    display: none;
  }
}
::v-deep .preview-sign-image {

  max-width: 300px;
  position: relative;
  margin: 0 auto;
  .el-image {
    max-width: 300px;
    margin-top: 25px;
  }
  &:hover {
    cursor: pointer;
  }
}
@media (max-width: 1600px) {
  .box-card-information-administrative .aside__infomation{
    max-width: 230px;
    width: 200px;
  }
  .aside__infomation .div-avatar .el-image{
    width: 170px;
    height: 170px;
  }
  .box-card-information-administrative .main__infomation{
    width: calc(100% - 200px);
  }
}
@media (max-width: 1470px) {
  ::v-deep .el-form-item__content{
    margin-left: 0 !important;
  }
}
@media (max-width: 1440px) {
  ::v-deep .employee-sign {
    .el-upload-dragger {
      width: 300px;
    }
  }
  .preview-sign-image {
    max-width: 250px;
    .el-image {
      max-width: 250px;
    }
  }
}
@media (max-width: 900px) {
  .w__900{
    flex-direction: column;
  }
  .box-card-information-administrative .aside__infomation{
    width: 100%;
    max-width: 100%;
  }
  .box-card-information-administrative .main__infomation{
    width: 100%;
  }
}
@media (max-width: 576px) {
  .subsidize .el-form-item .el-form-item__content .icon-remove {
    text-align: center;
  }
}
@media (max-width: 1080px){
  .col-md-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
